var Kt = Object.defineProperty;
var qt = (t, e, r) => e in t ? Kt(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r;
var P = (t, e, r) => (qt(t, typeof e != "symbol" ? e + "" : e, r), r);
function jt(t) {
  return t != null;
}
var W = /* @__PURE__ */ ((t) => (t[t.Silent = 0] = "Silent", t[t.Error = 1] = "Error", t[t.Warn = 2] = "Warn", t[t.Info = 3] = "Info", t[t.Debug = 4] = "Debug", t[t.Verbose = 5] = "Verbose", t))(W || {});
class G {
  static setLogLevel(e) {
    this.logLevel = e;
  }
  static log(e, r = this.logLevel) {
    const n = `[Purchases] ${e}`;
    if (!(this.logLevel < r || r === W.Silent))
      switch (r) {
        case W.Error:
          console.error(n);
          break;
        case W.Warn:
          console.warn(n);
          break;
        case W.Info:
          console.info(n);
          break;
        case W.Debug:
          console.debug(n);
          break;
        case W.Verbose:
          console.debug(n);
          break;
      }
  }
  static errorLog(e) {
    this.log(e, W.Error);
  }
  static warnLog(e) {
    this.log(e, W.Warn);
  }
  static infoLog(e) {
    this.log(e, W.Info);
  }
  static debugLog(e) {
    this.log(e, W.Debug);
  }
  static verboseLog(e) {
    this.log(e, W.Verbose);
  }
}
P(G, "logLevel", W.Silent);
var ne = /* @__PURE__ */ ((t) => (t.Year = "year", t.Month = "month", t.Week = "week", t.Day = "day", t))(ne || {});
function Je(t) {
  const e = t.match(/^PT?([0-9]+)([MDYW])$/);
  if (!e || e.length < 3)
    return G.errorLog(`Invalid ISO 8601 duration format: ${t}`), null;
  const r = parseInt(e[1]);
  switch (e[2]) {
    case "Y":
      return {
        number: r,
        unit: "year"
        /* Year */
      };
    case "M":
      return {
        number: r,
        unit: "month"
        /* Month */
      };
    case "W":
      return {
        number: r,
        unit: "week"
        /* Week */
      };
    case "D":
      return {
        number: r,
        unit: "day"
        /* Day */
      };
    default:
      return G.errorLog(`Invalid ISO 8601 unit duration format: ${t}`), null;
  }
}
const Ve = (t, e) => {
  const r = t / 100;
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: e
  }).format(r);
}, Jt = (t) => {
  const e = t.number;
  if (e === 1)
    switch (t.unit) {
      case ne.Year:
        return "yearly";
      case ne.Month:
        return "monthly";
      case ne.Week:
        return "weekly";
      case ne.Day:
        return "daily";
    }
  else
    return `every ${e} ${t.unit}s`;
}, Vt = (t) => {
  const e = t.number;
  if (e === 1)
    switch (t.unit) {
      case ne.Year:
        return "1 year";
      case ne.Month:
        return "1 month";
      case ne.Week:
        return "1 week";
      case ne.Day:
        return "1 day";
    }
  else
    return `${e} ${t.unit}s`;
}, nt = (t) => {
  const e = Je(t);
  return e ? Jt(e) : "unknown";
}, Wt = (t) => {
  const e = Je(t);
  return e ? Vt(e) : "unknown";
};
var zt = /* @__PURE__ */ ((t) => (t.Unknown = "unknown", t.Custom = "custom", t.Lifetime = "$rc_lifetime", t.Annual = "$rc_annual", t.SixMonth = "$rc_six_month", t.ThreeMonth = "$rc_three_month", t.TwoMonth = "$rc_two_month", t.Monthly = "$rc_monthly", t.Weekly = "$rc_weekly", t))(zt || {});
const Xt = (t) => ({
  amount: t.amount,
  currency: t.currency,
  formattedPrice: Ve(t.amount, t.currency)
}), rt = (t) => {
  const e = t.period_duration;
  return {
    periodDuration: e,
    period: e ? Je(e) : null,
    cycleCount: t.cycle_count,
    price: t.price ? Xt(t.price) : null
  };
}, Zt = (t) => t.base == null ? (G.debugLog("Missing base phase for subscription option. Ignoring."), null) : {
  id: t.id,
  base: rt(t.base),
  trial: t.trial ? rt(t.trial) : null
}, en = (t, e) => {
  const r = {};
  if (Object.entries(t.subscription_options).forEach(
    ([s, l]) => {
      const c = Zt(l);
      c != null && (r[s] = c);
    }
  ), Object.keys(r).length === 0)
    return G.debugLog(
      `Product ${t.identifier} has no subscription options. Ignoring.`
    ), null;
  const n = t.default_subscription_option_id, i = n && n in r ? r[n] : null;
  if (i == null)
    return G.debugLog(
      `Product ${t.identifier} has no default subscription option. Ignoring.`
    ), null;
  const o = i.base.price;
  return o == null ? (G.debugLog(
    `Product ${t.identifier} default option has no base price. Ignoring.`
  ), null) : {
    identifier: t.identifier,
    displayName: t.title,
    title: t.title,
    description: t.description,
    currentPrice: o,
    normalPeriodDuration: i.base.periodDuration,
    presentedOfferingIdentifier: e,
    defaultSubscriptionOption: i,
    subscriptionOptions: r
  };
}, tn = (t, e, r) => {
  const n = r[e.platform_product_identifier];
  if (n === void 0)
    return null;
  const i = en(n, t);
  return i === null ? null : {
    identifier: e.identifier,
    rcBillingProduct: i,
    packageType: nn(e.identifier)
  };
}, it = (t, e) => {
  const r = t.packages.map(
    (i) => tn(t.identifier, i, e)
  ).filter(jt), n = {};
  for (const i of r)
    i != null && (n[i.identifier] = i);
  return r.length == 0 ? null : {
    identifier: t.identifier,
    serverDescription: t.description,
    metadata: t.metadata,
    packagesById: n,
    availablePackages: r,
    lifetime: n.$rc_lifetime ?? null,
    annual: n.$rc_annual ?? null,
    sixMonth: n.$rc_six_month ?? null,
    threeMonth: n.$rc_three_month ?? null,
    twoMonth: n.$rc_two_month ?? null,
    monthly: n.$rc_monthly ?? null,
    weekly: n.$rc_weekly ?? null
  };
};
function nn(t) {
  switch (t) {
    case "$rc_lifetime":
      return "$rc_lifetime";
    case "$rc_annual":
      return "$rc_annual";
    case "$rc_six_month":
      return "$rc_six_month";
    case "$rc_three_month":
      return "$rc_three_month";
    case "$rc_two_month":
      return "$rc_two_month";
    case "$rc_monthly":
      return "$rc_monthly";
    case "$rc_weekly":
      return "$rc_weekly";
    default:
      return t.startsWith("$rc_") ? "unknown" : "custom";
  }
}
function v() {
}
function rn(t, e) {
  for (const r in e)
    t[r] = e[r];
  return (
    /** @type {T & S} */
    t
  );
}
function Bt(t) {
  return t();
}
function ot() {
  return /* @__PURE__ */ Object.create(null);
}
function Ie(t) {
  t.forEach(Bt);
}
function ce(t) {
  return typeof t == "function";
}
function T(t, e) {
  return t != t ? e == e : t !== e || t && typeof t == "object" || typeof t == "function";
}
let De;
function ee(t, e) {
  return t === e ? !0 : (De || (De = document.createElement("a")), De.href = e, t === De.href);
}
function st(t) {
  return t.split(",").map((e) => e.trim().split(" ").filter(Boolean));
}
function on(t, e) {
  const r = st(t.srcset), n = st(e || "");
  return n.length === r.length && n.every(
    ([i, o], s) => o === r[s][1] && // We need to test both ways because Vite will create an a full URL with
    // `new URL(asset, import.meta.url).href` for the client when `base: './'`, and the
    // relative URLs inside srcset are not automatically resolved to absolute URLs by
    // browsers (in contrast to img.src). This means both SSR and DOM code could
    // contain relative or absolute URLs.
    (ee(r[s][0], i) || ee(i, r[s][0]))
  );
}
function sn(t) {
  return Object.keys(t).length === 0;
}
function q(t, e, r, n) {
  if (t) {
    const i = Dt(t, e, r, n);
    return t[0](i);
  }
}
function Dt(t, e, r, n) {
  return t[1] && n ? rn(r.ctx.slice(), t[1](n(e))) : r.ctx;
}
function j(t, e, r, n) {
  if (t[2] && n) {
    const i = t[2](n(r));
    if (e.dirty === void 0)
      return i;
    if (typeof i == "object") {
      const o = [], s = Math.max(e.dirty.length, i.length);
      for (let l = 0; l < s; l += 1)
        o[l] = e.dirty[l] | i[l];
      return o;
    }
    return e.dirty | i;
  }
  return e.dirty;
}
function J(t, e, r, n, i, o) {
  if (i) {
    const s = Dt(e, r, n, o);
    t.p(s, i);
  }
}
function V(t) {
  if (t.ctx.length > 32) {
    const e = [], r = t.ctx.length / 32;
    for (let n = 0; n < r; n++)
      e[n] = -1;
    return e;
  }
  return -1;
}
function Ae(t) {
  return t ?? "";
}
function M(t, e) {
  t.appendChild(e);
}
function x(t, e, r) {
  const n = ln(t);
  if (!n.getElementById(e)) {
    const i = k("style");
    i.id = e, i.textContent = r, cn(n, i);
  }
}
function ln(t) {
  if (!t)
    return document;
  const e = t.getRootNode ? t.getRootNode() : t.ownerDocument;
  return e && /** @type {ShadowRoot} */
  e.host ? (
    /** @type {ShadowRoot} */
    e
  ) : t.ownerDocument;
}
function cn(t, e) {
  return M(
    /** @type {Document} */
    t.head || t,
    e
  ), e.sheet;
}
function p(t, e, r) {
  t.insertBefore(e, r || null);
}
function g(t) {
  t.parentNode && t.parentNode.removeChild(t);
}
function k(t) {
  return document.createElement(t);
}
function L(t) {
  return document.createTextNode(t);
}
function Q() {
  return L(" ");
}
function te() {
  return L("");
}
function we(t, e, r, n) {
  return t.addEventListener(e, r, n), () => t.removeEventListener(e, r, n);
}
function Ct(t) {
  return function(e) {
    return e.preventDefault(), t.call(this, e);
  };
}
function _(t, e, r) {
  r == null ? t.removeAttribute(e) : t.getAttribute(e) !== r && t.setAttribute(e, r);
}
const an = ["width", "height"];
function un(t, e) {
  const r = Object.getOwnPropertyDescriptors(t.__proto__);
  for (const n in e)
    e[n] == null ? t.removeAttribute(n) : n === "style" ? t.style.cssText = e[n] : n === "__value" ? t.value = t[n] = e[n] : r[n] && r[n].set && an.indexOf(n) === -1 ? t[n] = e[n] : _(t, n, e[n]);
}
function fn(t, e) {
  Object.keys(e).forEach((r) => {
    dn(t, r, e[r]);
  });
}
function dn(t, e, r) {
  const n = e.toLowerCase();
  n in t ? t[n] = typeof t[n] == "boolean" && r === "" ? !0 : r : e in t ? t[e] = typeof t[e] == "boolean" && r === "" ? !0 : r : _(t, e, r);
}
function mn(t) {
  return /-/.test(t) ? fn : un;
}
function gn(t) {
  return Array.from(t.childNodes);
}
function ae(t, e) {
  e = "" + e, t.data !== e && (t.data = /** @type {string} */
  e);
}
function lt(t, e) {
  t.value = e ?? "";
}
function pn(t, e, { bubbles: r = !1, cancelable: n = !1 } = {}) {
  return new CustomEvent(t, { detail: e, bubbles: r, cancelable: n });
}
let Ee;
function _e(t) {
  Ee = t;
}
function ke() {
  if (!Ee)
    throw new Error("Function called outside component initialization");
  return Ee;
}
function _n(t) {
  ke().$$.before_update.push(t);
}
function Se(t) {
  ke().$$.on_mount.push(t);
}
function hn() {
  const t = ke();
  return (e, r, { cancelable: n = !1 } = {}) => {
    const i = t.$$.callbacks[e];
    if (i) {
      const o = pn(
        /** @type {string} */
        e,
        r,
        { cancelable: n }
      );
      return i.slice().forEach((s) => {
        s.call(t, o);
      }), !o.defaultPrevented;
    }
    return !0;
  };
}
function An(t, e) {
  return ke().$$.context.set(t, e), e;
}
function En(t) {
  return ke().$$.context.get(t);
}
function Pt(t, e) {
  const r = t.$$.callbacks[e.type];
  r && r.slice().forEach((n) => n.call(this, e));
}
const se = [], Ue = [];
let le = [];
const Ye = [], bn = /* @__PURE__ */ Promise.resolve();
let He = !1;
function In() {
  He || (He = !0, bn.then(Mt));
}
function Ke(t) {
  le.push(t);
}
function wn(t) {
  Ye.push(t);
}
const xe = /* @__PURE__ */ new Set();
let ie = 0;
function Mt() {
  if (ie !== 0)
    return;
  const t = Ee;
  do {
    try {
      for (; ie < se.length; ) {
        const e = se[ie];
        ie++, _e(e), kn(e.$$);
      }
    } catch (e) {
      throw se.length = 0, ie = 0, e;
    }
    for (_e(null), se.length = 0, ie = 0; Ue.length; )
      Ue.pop()();
    for (let e = 0; e < le.length; e += 1) {
      const r = le[e];
      xe.has(r) || (xe.add(r), r());
    }
    le.length = 0;
  } while (se.length);
  for (; Ye.length; )
    Ye.pop()();
  He = !1, xe.clear(), _e(t);
}
function kn(t) {
  if (t.fragment !== null) {
    t.update(), Ie(t.before_update);
    const e = t.dirty;
    t.dirty = [-1], t.fragment && t.fragment.p(t.ctx, e), t.after_update.forEach(Ke);
  }
}
function yn(t) {
  const e = [], r = [];
  le.forEach((n) => t.indexOf(n) === -1 ? e.push(n) : r.push(n)), r.forEach((n) => n()), le = e;
}
const Qe = /* @__PURE__ */ new Set();
let re;
function H() {
  re = {
    r: 0,
    c: [],
    p: re
    // parent group
  };
}
function K() {
  re.r || Ie(re.c), re = re.p;
}
function f(t, e) {
  t && t.i && (Qe.delete(t), t.i(e));
}
function d(t, e, r, n) {
  if (t && t.o) {
    if (Qe.has(t))
      return;
    Qe.add(t), re.c.push(() => {
      Qe.delete(t), n && (r && t.d(1), n());
    }), t.o(e);
  } else
    n && n();
}
function vn(t, e, r) {
  const n = t.$$.props[e];
  n !== void 0 && (t.$$.bound[n] = r, r(t.$$.ctx[n]));
}
function w(t) {
  t && t.c();
}
function b(t, e, r) {
  const { fragment: n, after_update: i } = t.$$;
  n && n.m(e, r), Ke(() => {
    const o = t.$$.on_mount.map(Bt).filter(ce);
    t.$$.on_destroy ? t.$$.on_destroy.push(...o) : Ie(o), t.$$.on_mount = [];
  }), i.forEach(Ke);
}
function I(t, e) {
  const r = t.$$;
  r.fragment !== null && (yn(r.after_update), Ie(r.on_destroy), r.fragment && r.fragment.d(e), r.on_destroy = r.fragment = null, r.ctx = []);
}
function $n(t, e) {
  t.$$.dirty[0] === -1 && (se.push(t), In(), t.$$.dirty.fill(0)), t.$$.dirty[e / 31 | 0] |= 1 << e % 31;
}
function N(t, e, r, n, i, o, s = null, l = [-1]) {
  const c = Ee;
  _e(t);
  const a = t.$$ = {
    fragment: null,
    ctx: [],
    // state
    props: o,
    update: v,
    not_equal: i,
    bound: ot(),
    // lifecycle
    on_mount: [],
    on_destroy: [],
    on_disconnect: [],
    before_update: [],
    after_update: [],
    context: new Map(e.context || (c ? c.$$.context : [])),
    // everything else
    callbacks: ot(),
    dirty: l,
    skip_bound: !1,
    root: e.target || c.$$.root
  };
  s && s(a.root);
  let u = !1;
  if (a.ctx = r ? r(t, e.props || {}, (m, h, ...y) => {
    const E = y.length ? y[0] : h;
    return a.ctx && i(a.ctx[m], a.ctx[m] = E) && (!a.skip_bound && a.bound[m] && a.bound[m](E), u && $n(t, m)), h;
  }) : [], a.update(), u = !0, Ie(a.before_update), a.fragment = n ? n(a.ctx) : !1, e.target) {
    if (e.hydrate) {
      const m = gn(e.target);
      a.fragment && a.fragment.l(m), m.forEach(g);
    } else
      a.fragment && a.fragment.c();
    e.intro && f(t.$$.fragment), b(t, e.target, e.anchor), Mt();
  }
  _e(c);
}
class U {
  constructor() {
    /**
     * ### PRIVATE API
     *
     * Do not use, may change at any time
     *
     * @type {any}
     */
    P(this, "$$");
    /**
     * ### PRIVATE API
     *
     * Do not use, may change at any time
     *
     * @type {any}
     */
    P(this, "$$set");
  }
  /** @returns {void} */
  $destroy() {
    I(this, 1), this.$destroy = v;
  }
  /**
   * @template {Extract<keyof Events, string>} K
   * @param {K} type
   * @param {((e: Events[K]) => void) | null | undefined} callback
   * @returns {() => void}
   */
  $on(e, r) {
    if (!ce(r))
      return v;
    const n = this.$$.callbacks[e] || (this.$$.callbacks[e] = []);
    return n.push(r), () => {
      const i = n.indexOf(r);
      i !== -1 && n.splice(i, 1);
    };
  }
  /**
   * @param {Partial<Props>} props
   * @returns {void}
   */
  $set(e) {
    this.$$set && !sn(e) && (this.$$.skip_bound = !0, this.$$set(e), this.$$.skip_bound = !1);
  }
}
const Bn = "4";
typeof window < "u" && (window.__svelte || (window.__svelte = { v: /* @__PURE__ */ new Set() })).v.add(Bn);
function Dn(t) {
  x(t, "svelte-1bzqb13", ".rcb-modal-section.svelte-1bzqb13{padding:8px 0px;display:flex}section.rcb-modal-section.svelte-1bzqb13{flex-grow:1}.rcb-modal-section.svelte-1bzqb13:last-of-type{padding:0}");
}
function Fe(t) {
  let e, r;
  const n = (
    /*#slots*/
    t[2].default
  ), i = q(
    n,
    t,
    /*$$scope*/
    t[1],
    null
  );
  return {
    c() {
      e = k(
        /*as*/
        t[0]
      ), i && i.c(), mn(
        /*as*/
        t[0]
      )(e, {
        class: Ae("rcb-modal-section") + " svelte-1bzqb13"
      });
    },
    m(o, s) {
      p(o, e, s), i && i.m(e, null), r = !0;
    },
    p(o, s) {
      i && i.p && (!r || s & /*$$scope*/
      2) && J(
        i,
        n,
        o,
        /*$$scope*/
        o[1],
        r ? j(
          n,
          /*$$scope*/
          o[1],
          s,
          null
        ) : V(
          /*$$scope*/
          o[1]
        ),
        null
      );
    },
    i(o) {
      r || (f(i, o), r = !0);
    },
    o(o) {
      d(i, o), r = !1;
    },
    d(o) {
      o && g(e), i && i.d(o);
    }
  };
}
function Cn(t) {
  let e = (
    /*as*/
    t[0]
  ), r, n, i = (
    /*as*/
    t[0] && Fe(t)
  );
  return {
    c() {
      i && i.c(), r = te();
    },
    m(o, s) {
      i && i.m(o, s), p(o, r, s), n = !0;
    },
    p(o, [s]) {
      /*as*/
      o[0] ? e ? T(
        e,
        /*as*/
        o[0]
      ) ? (i.d(1), i = Fe(o), e = /*as*/
      o[0], i.c(), i.m(r.parentNode, r)) : i.p(o, s) : (i = Fe(o), e = /*as*/
      o[0], i.c(), i.m(r.parentNode, r)) : e && (i.d(1), i = null, e = /*as*/
      o[0]);
    },
    i(o) {
      n || (f(i, o), n = !0);
    },
    o(o) {
      d(i, o), n = !1;
    },
    d(o) {
      o && g(r), i && i.d(o);
    }
  };
}
function Pn(t, e, r) {
  let { $$slots: n = {}, $$scope: i } = e, { as: o = "section" } = e;
  return t.$$set = (s) => {
    "as" in s && r(0, o = s.as), "$$scope" in s && r(1, i = s.$$scope);
  }, [o, i, n];
}
class ue extends U {
  constructor(e) {
    super(), N(this, e, Pn, Cn, T, { as: 0 }, Dn);
  }
}
function Mn(t) {
  x(t, "svelte-gf0gr5", ".rcb-pricing-info.svelte-gf0gr5{display:flex;flex-direction:column;margin-top:102px;font-weight:500}.rcb-product-price.svelte-gf0gr5{font-size:24px;margin:12px 0px}.rcb-product-price-after-trial.svelte-gf0gr5{margin-bottom:12px}.rcb-product-details.svelte-gf0gr5{opacity:0.6;list-style-type:disc;list-style-position:inside;margin:0px;padding:0px}@media screen and (max-width: 960px){.rcb-pricing-info.svelte-gf0gr5{margin-top:48px}}");
}
function Qn(t) {
  let e = Wt(
    /*trial*/
    t[1].periodDuration
  ) + "", r, n;
  return {
    c() {
      r = L(e), n = L(" free trial");
    },
    m(i, o) {
      p(i, r, o), p(i, n, o);
    },
    p: v,
    d(i) {
      i && (g(r), g(n));
    }
  };
}
function Tn(t) {
  let e = (
    /*basePrice*/
    (t[2].currency || "") + ""
  ), r, n, i = Ve(
    /*basePrice*/
    t[2].amount,
    /*basePrice*/
    t[2].currency
  ) + "", o;
  return {
    c() {
      r = L(e), n = Q(), o = L(i);
    },
    m(s, l) {
      p(s, r, l), p(s, n, l), p(s, o, l);
    },
    p: v,
    d(s) {
      s && (g(r), g(n), g(o));
    }
  };
}
function Nn(t) {
  let e;
  return {
    c() {
      e = k("span"), e.textContent = `${/*trial*/
      t[1] && /*basePrice*/
      t[2] && `${/*basePrice*/
      t[2].currency} ${Ve(
        /*basePrice*/
        t[2].amount,
        /*basePrice*/
        t[2].currency
      )} after end of trial`}`, _(e, "class", "rcb-product-price-after-trial svelte-gf0gr5");
    },
    m(r, n) {
      p(r, e, n);
    },
    p: v,
    d(r) {
      r && g(e);
    }
  };
}
function ct(t) {
  let e, r, n = nt(
    /*productDetails*/
    t[0].normalPeriodDuration
  ) + "", i;
  return {
    c() {
      e = k("li"), r = L("Renews "), i = L(n);
    },
    m(o, s) {
      p(o, e, s), M(e, r), M(e, i);
    },
    p(o, s) {
      s & /*productDetails*/
      1 && n !== (n = nt(
        /*productDetails*/
        o[0].normalPeriodDuration
      ) + "") && ae(i, n);
    },
    d(o) {
      o && g(e);
    }
  };
}
function Un(t) {
  var C, ve;
  let e, r, n = (
    /*productDetails*/
    t[0].displayName + ""
  ), i, o, s, l, c, a, u, m, h, y, E, B = (
    /*trial*/
    ((C = t[1]) == null ? void 0 : C.periodDuration) && Qn(t)
  ), A = !/*trial*/
  ((ve = t[1]) != null && ve.periodDuration) && /*basePrice*/
  t[2] && Tn(t), $ = (
    /*trial*/
    t[1] && /*basePrice*/
    t[2] && Nn(t)
  ), R = (
    /*productDetails*/
    t[0].normalPeriodDuration && ct(t)
  );
  return {
    c() {
      e = k("div"), r = k("span"), i = L(n), o = Q(), s = k("span"), B && B.c(), l = Q(), A && A.c(), c = Q(), $ && $.c(), a = Q(), u = k("ul"), R && R.c(), m = Q(), h = k("li"), h.textContent = "Continues until canceled", y = Q(), E = k("li"), E.textContent = "Cancel anytime", _(s, "class", "rcb-product-price svelte-gf0gr5"), _(u, "class", "rcb-product-details svelte-gf0gr5"), _(e, "class", "rcb-pricing-info svelte-gf0gr5");
    },
    m(F, S) {
      p(F, e, S), M(e, r), M(r, i), M(e, o), M(e, s), B && B.m(s, null), M(s, l), A && A.m(s, null), M(e, c), $ && $.m(e, null), M(e, a), M(e, u), R && R.m(u, null), M(u, m), M(u, h), M(u, y), M(u, E);
    },
    p(F, S) {
      var $e, Be;
      S & /*productDetails*/
      1 && n !== (n = /*productDetails*/
      F[0].displayName + "") && ae(i, n), /*trial*/
      ($e = F[1]) != null && $e.periodDuration && B.p(F, S), !/*trial*/
      ((Be = F[1]) != null && Be.periodDuration) && /*basePrice*/
      F[2] && A.p(F, S), /*trial*/
      F[1] && /*basePrice*/
      F[2] && $.p(F, S), /*productDetails*/
      F[0].normalPeriodDuration ? R ? R.p(F, S) : (R = ct(F), R.c(), R.m(u, m)) : R && (R.d(1), R = null);
    },
    d(F) {
      F && g(e), B && B.d(), A && A.d(), $ && $.d(), R && R.d();
    }
  };
}
function Rn(t) {
  let e, r;
  return e = new ue({
    props: {
      $$slots: { default: [Un] },
      $$scope: { ctx: t }
    }
  }), {
    c() {
      w(e.$$.fragment);
    },
    m(n, i) {
      b(e, n, i), r = !0;
    },
    p(n, [i]) {
      const o = {};
      i & /*$$scope, productDetails*/
      33 && (o.$$scope = { dirty: i, ctx: n }), e.$set(o);
    },
    i(n) {
      r || (f(e.$$.fragment, n), r = !0);
    },
    o(n) {
      d(e.$$.fragment, n), r = !1;
    },
    d(n) {
      I(e, n);
    }
  };
}
function Sn(t, e, r) {
  var c;
  let { productDetails: n } = e, { purchaseOption: i } = e;
  const o = i, s = o == null ? void 0 : o.trial, l = (c = o == null ? void 0 : o.base) == null ? void 0 : c.price;
  return t.$$set = (a) => {
    "productDetails" in a && r(0, n = a.productDetails), "purchaseOption" in a && r(3, i = a.purchaseOption);
  }, [n, s, l, i];
}
class Qt extends U {
  constructor(e) {
    super(), N(this, e, Sn, Rn, T, { productDetails: 0, purchaseOption: 3 }, Mn);
  }
}
const On = "data:image/gif;base64,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";
function Ln(t) {
  let e, r;
  return {
    c() {
      e = k("img"), ee(e.src, r = On) || _(e, "src", r), _(e, "alt", "spinner");
    },
    m(n, i) {
      p(n, e, i);
    },
    p: v,
    i: v,
    o: v,
    d(n) {
      n && g(e);
    }
  };
}
class xn extends U {
  constructor(e) {
    super(), N(this, e, null, Ln, T, {});
  }
}
function Fn(t) {
  x(t, "svelte-1mxx341", ".rcb-modal-loader.svelte-1mxx341{width:100%;flex-grow:1;min-height:100%;display:flex;justify-content:center;align-items:center}");
}
function Gn(t) {
  let e, r, n;
  return r = new xn({}), {
    c() {
      e = k("div"), w(r.$$.fragment), _(e, "class", "rcb-modal-loader svelte-1mxx341");
    },
    m(i, o) {
      p(i, e, o), b(r, e, null), n = !0;
    },
    p: v,
    i(i) {
      n || (f(r.$$.fragment, i), n = !0);
    },
    o(i) {
      d(r.$$.fragment, i), n = !1;
    },
    d(i) {
      i && g(e), I(r);
    }
  };
}
class We extends U {
  constructor(e) {
    super(), N(this, e, null, Gn, T, {}, Fn);
  }
}
var Z = /* @__PURE__ */ ((t) => (t[t.UnknownError = 0] = "UnknownError", t[t.UserCancelledError = 1] = "UserCancelledError", t[t.StoreProblemError = 2] = "StoreProblemError", t[t.PurchaseNotAllowedError = 3] = "PurchaseNotAllowedError", t[t.PurchaseInvalidError = 4] = "PurchaseInvalidError", t[t.ProductNotAvailableForPurchaseError = 5] = "ProductNotAvailableForPurchaseError", t[t.ProductAlreadyPurchasedError = 6] = "ProductAlreadyPurchasedError", t[t.ReceiptAlreadyInUseError = 7] = "ReceiptAlreadyInUseError", t[t.InvalidReceiptError = 8] = "InvalidReceiptError", t[t.MissingReceiptFileError = 9] = "MissingReceiptFileError", t[t.NetworkError = 10] = "NetworkError", t[t.InvalidCredentialsError = 11] = "InvalidCredentialsError", t[t.UnexpectedBackendResponseError = 12] = "UnexpectedBackendResponseError", t[t.InvalidAppUserIdError = 14] = "InvalidAppUserIdError", t[t.OperationAlreadyInProgressError = 15] = "OperationAlreadyInProgressError", t[t.UnknownBackendError = 16] = "UnknownBackendError", t[t.InvalidAppleSubscriptionKeyError = 17] = "InvalidAppleSubscriptionKeyError", t[t.IneligibleError = 18] = "IneligibleError", t[t.InsufficientPermissionsError = 19] = "InsufficientPermissionsError", t[t.PaymentPendingError = 20] = "PaymentPendingError", t[t.InvalidSubscriberAttributesError = 21] = "InvalidSubscriberAttributesError", t[t.LogOutWithAnonymousUserError = 22] = "LogOutWithAnonymousUserError", t[t.ConfigurationError = 23] = "ConfigurationError", t[t.UnsupportedError = 24] = "UnsupportedError", t[t.EmptySubscriberAttributesError = 25] = "EmptySubscriberAttributesError", t[t.CustomerInfoError = 28] = "CustomerInfoError", t[t.SignatureVerificationError = 36] = "SignatureVerificationError", t[t.InvalidEmailError = 38] = "InvalidEmailError", t))(Z || {});
class he {
  static getPublicMessage(e) {
    switch (e) {
      case 0:
        return "Unknown error.";
      case 1:
        return "Purchase was cancelled.";
      case 2:
        return "There was a problem with the store.";
      case 3:
        return "The device or user is not allowed to make the purchase.";
      case 4:
        return "One or more of the arguments provided are invalid.";
      case 5:
        return "The product is not available for purchase.";
      case 6:
        return "This product is already active for the user.";
      case 7:
        return "There is already another active subscriber using the same receipt.";
      case 8:
        return "The receipt is not valid.";
      case 9:
        return "The receipt is missing.";
      case 10:
        return "Error performing request.";
      case 11:
        return "There was a credentials issue. Check the underlying error for more details.";
      case 12:
        return "Received unexpected response from the backend.";
      case 14:
        return "The app user id is not valid.";
      case 15:
        return "The operation is already in progress.";
      case 16:
        return "There was an unknown backend error.";
      case 17:
        return "Apple Subscription Key is invalid or not present. In order to provide subscription offers, you must first generate a subscription key. Please see https://docs.revenuecat.com/docs/ios-subscription-offers for more info.";
      case 18:
        return "The User is ineligible for that action.";
      case 19:
        return "App does not have sufficient permissions to make purchases.";
      case 20:
        return "The payment is pending.";
      case 21:
        return "One or more of the attributes sent could not be saved.";
      case 22:
        return "Called logOut but the current user is anonymous.";
      case 23:
        return "There is an issue with your configuration. Check the underlying error for more details.";
      case 24:
        return "There was a problem with the operation. Looks like we doesn't support that yet. Check the underlying error for more details.";
      case 25:
        return "A request for subscriber attributes returned none.";
      case 28:
        return "There was a problem related to the customer info.";
      case 36:
        return "Request failed signature verification. Please see https://rev.cat/trusted-entitlements for more info.";
      case 38:
        return "Email is not valid. Please provide a valid email address.";
    }
  }
  static getErrorCodeForBackendErrorCode(e) {
    switch (e) {
      case 7101:
        return 2;
      case 7102:
        return 7;
      case 7103:
        return 8;
      case 7107:
      case 7224:
      case 7225:
        return 11;
      case 7105:
      case 7106:
      case 7814:
        return 4;
      case 7772:
        return 6;
      case 7220:
        return 14;
      case 7229:
        return 2;
      case 7230:
      case 7e3:
        return 23;
      case 7231:
        return 2;
      case 7232:
        return 18;
      case 7263:
      case 7264:
        return 21;
      case 7104:
      case 7234:
      case 7226:
      case 7110:
        return 12;
      case 7662:
        return 24;
      case 7012:
      case 7834:
        return 38;
    }
  }
  static convertCodeToBackendErrorCode(e) {
    return e in Tt ? e : null;
  }
  static convertPurchaseFlowErrorCodeToErrorCode(e) {
    switch (e) {
      case O.ErrorSettingUpPurchase:
        return 2;
      case O.ErrorChargingPayment:
        return 20;
      case O.NetworkError:
        return 10;
      case O.MissingEmailError:
        return 4;
      case O.StripeError:
        return 2;
      case O.UnknownError:
        return 0;
      case O.AlreadySubscribedError:
        return 6;
    }
  }
}
var Tt = /* @__PURE__ */ ((t) => (t[t.BackendInvalidPlatform = 7e3] = "BackendInvalidPlatform", t[t.BackendInvalidEmail = 7012] = "BackendInvalidEmail", t[t.BackendStoreProblem = 7101] = "BackendStoreProblem", t[t.BackendCannotTransferPurchase = 7102] = "BackendCannotTransferPurchase", t[t.BackendInvalidReceiptToken = 7103] = "BackendInvalidReceiptToken", t[t.BackendInvalidAppStoreSharedSecret = 7104] = "BackendInvalidAppStoreSharedSecret", t[t.BackendInvalidPaymentModeOrIntroPriceNotProvided = 7105] = "BackendInvalidPaymentModeOrIntroPriceNotProvided", t[t.BackendProductIdForGoogleReceiptNotProvided = 7106] = "BackendProductIdForGoogleReceiptNotProvided", t[t.BackendInvalidPlayStoreCredentials = 7107] = "BackendInvalidPlayStoreCredentials", t[t.BackendInternalServerError = 7110] = "BackendInternalServerError", t[t.BackendEmptyAppUserId = 7220] = "BackendEmptyAppUserId", t[t.BackendInvalidAuthToken = 7224] = "BackendInvalidAuthToken", t[t.BackendInvalidAPIKey = 7225] = "BackendInvalidAPIKey", t[t.BackendBadRequest = 7226] = "BackendBadRequest", t[t.BackendPlayStoreQuotaExceeded = 7229] = "BackendPlayStoreQuotaExceeded", t[t.BackendPlayStoreInvalidPackageName = 7230] = "BackendPlayStoreInvalidPackageName", t[t.BackendPlayStoreGenericError = 7231] = "BackendPlayStoreGenericError", t[t.BackendUserIneligibleForPromoOffer = 7232] = "BackendUserIneligibleForPromoOffer", t[t.BackendInvalidAppleSubscriptionKey = 7234] = "BackendInvalidAppleSubscriptionKey", t[t.BackendInvalidSubscriberAttributes = 7263] = "BackendInvalidSubscriberAttributes", t[t.BackendInvalidSubscriberAttributesBody = 7264] = "BackendInvalidSubscriberAttributesBody", t[t.BackendProductIDsMalformed = 7662] = "BackendProductIDsMalformed", t[t.BackendAlreadySubscribedError = 7772] = "BackendAlreadySubscribedError", t[t.BackendOfferNotFound = 7814] = "BackendOfferNotFound", t[t.BackendNoMXRecordsFound = 7834] = "BackendNoMXRecordsFound", t))(Tt || {});
class z extends Error {
  constructor(r, n, i) {
    super(n);
    P(this, "toString", () => `PurchasesError(code: ${Z[this.errorCode]}, message: ${this.message})`);
    this.errorCode = r, this.underlyingErrorMessage = i;
  }
  /** @internal */
  static getForBackendError(r, n) {
    const i = he.getErrorCodeForBackendErrorCode(r);
    return new z(
      i,
      he.getPublicMessage(i),
      n
    );
  }
  /** @internal */
  static getForPurchasesFlowError(r) {
    return new z(
      he.convertPurchaseFlowErrorCodeToErrorCode(
        r.errorCode
      ),
      r.message,
      r.underlyingErrorMessage
    );
  }
}
class Yn extends Error {
  constructor() {
    super("Purchases must be configured before calling getInstance");
  }
}
var ge = /* @__PURE__ */ ((t) => (t.Started = "started", t.InProgress = "in_progress", t.Succeeded = "succeeded", t.Failed = "failed", t))(ge || {}), Te = /* @__PURE__ */ ((t) => (t[t.SetupIntentCreationFailed = 1] = "SetupIntentCreationFailed", t[t.PaymentMethodCreationFailed = 2] = "PaymentMethodCreationFailed", t[t.PaymentChargeFailed = 3] = "PaymentChargeFailed", t))(Te || {}), O = /* @__PURE__ */ ((t) => (t[t.ErrorSettingUpPurchase = 0] = "ErrorSettingUpPurchase", t[t.ErrorChargingPayment = 1] = "ErrorChargingPayment", t[t.UnknownError = 2] = "UnknownError", t[t.NetworkError = 3] = "NetworkError", t[t.StripeError = 4] = "StripeError", t[t.MissingEmailError = 5] = "MissingEmailError", t[t.AlreadySubscribedError = 6] = "AlreadySubscribedError", t))(O || {});
class Y extends Error {
  constructor(e, r, n) {
    super(r), this.errorCode = e, this.underlyingErrorMessage = n;
  }
  static fromPurchasesError(e, r) {
    let n;
    return e.errorCode === Z.ProductAlreadyPurchasedError ? n = 6 : e.errorCode === Z.InvalidEmailError ? n = 5 : n = r, new Y(
      n,
      e.message,
      e.underlyingErrorMessage
    );
  }
}
class Hn {
  constructor(e, r = 10) {
    P(this, "operationSessionId", null);
    P(this, "backend");
    P(this, "maxNumberAttempts");
    P(this, "waitMSBetweenAttempts", 1e3);
    this.backend = e, this.maxNumberAttempts = r;
  }
  async startPurchase(e, r, n, i, o) {
    try {
      const s = await this.backend.postSubscribe(
        e,
        r,
        i,
        o,
        n == null ? void 0 : n.id
      );
      return this.operationSessionId = s.operation_session_id, s;
    } catch (s) {
      if (s instanceof z)
        throw Y.fromPurchasesError(
          s,
          0
          /* ErrorSettingUpPurchase */
        );
      {
        const l = "Unknown error starting purchase: " + String(s);
        throw G.errorLog(l), new Y(
          2,
          l
        );
      }
    }
  }
  async pollCurrentPurchaseForCompletion() {
    const e = this.operationSessionId;
    if (!e)
      throw new Y(
        0,
        "No purchase in progress"
      );
    return new Promise((r, n) => {
      const i = (o = 1) => {
        if (o > this.maxNumberAttempts) {
          this.clearPurchaseInProgress(), n(
            new Y(
              2,
              "Max attempts reached trying to get successful purchase status"
            )
          );
          return;
        }
        this.backend.getCheckoutStatus(e).then((s) => {
          switch (s.operation.status) {
            case ge.Started:
            case ge.InProgress:
              setTimeout(
                () => i(o + 1),
                this.waitMSBetweenAttempts
              );
              break;
            case ge.Succeeded:
              this.clearPurchaseInProgress(), r();
              return;
            case ge.Failed:
              this.clearPurchaseInProgress(), this.handlePaymentError(
                s.operation.error,
                n
              );
          }
        }).catch((s) => {
          const l = Y.fromPurchasesError(
            s,
            3
            /* NetworkError */
          );
          n(l);
        });
      };
      i();
    });
  }
  clearPurchaseInProgress() {
    this.operationSessionId = null;
  }
  handlePaymentError(e, r) {
    if (e == null) {
      r(
        new Y(
          2,
          "Got an error status but error field is empty."
        )
      );
      return;
    }
    switch (e.code) {
      case Te.SetupIntentCreationFailed:
        r(
          new Y(
            0,
            "Setup intent creation failed"
          )
        );
        return;
      case Te.PaymentMethodCreationFailed:
        r(
          new Y(
            0,
            "Payment method creation failed"
          )
        );
        return;
      case Te.PaymentChargeFailed:
        r(
          new Y(
            1,
            "Payment charge failed"
          )
        );
        return;
    }
  }
}
const Kn = "data:image/svg+xml,%3csvg%20width='124'%20height='124'%20viewBox='0%200%20124%20124'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3ccircle%20cx='62'%20cy='62'%20r='62'%20fill='%23767676'/%3e%3cpath%20d='M87.6668%2041.504L82.4968%2036.334L62.0002%2056.8307L41.5035%2036.334L36.3335%2041.504L56.8302%2062.0006L36.3335%2082.4973L41.5035%2087.6673L62.0002%2067.1706L82.4968%2087.6673L87.6668%2082.4973L67.1702%2062.0006L87.6668%2041.504Z'%20fill='white'/%3e%3c/svg%3e";
function qn(t) {
  x(t, "svelte-1609h93", "img.svelte-1609h93{width:124px;height:124px;margin:0 auto}");
}
function jn(t) {
  let e, r;
  return {
    c() {
      e = k("img"), ee(e.src, r = Kn) || _(e, "src", r), _(e, "alt", "icon"), _(e, "class", "rcb-ui-asset-icon svelte-1609h93");
    },
    m(n, i) {
      p(n, e, i);
    },
    p: v,
    i: v,
    o: v,
    d(n) {
      n && g(e);
    }
  };
}
class Jn extends U {
  constructor(e) {
    super(), N(this, e, null, jn, T, {}, qn);
  }
}
function Vn(t) {
  x(t, "svelte-1rmxk7q", "button.svelte-1rmxk7q{border:none;border-radius:56px;font-size:16px;cursor:pointer;height:56px;color:var(--rc-color-grey-text-dark);background-color:var(--rc-color-grey-ui-dark);display:flex;align-items:center;justify-content:center}button.intent-primary.svelte-1rmxk7q{background-color:var(--rc-color-grey-text-dark);color:var(--rc-color-white);font-size:16px}button.svelte-1rmxk7q:disabled{color:var(--rc-color-grey-text-light)}button.intent-primary.svelte-1rmxk7q:disabled{color:var(--rc-color-grey-text-light)}");
}
function Wn(t) {
  let e, r, n, i, o;
  const s = (
    /*#slots*/
    t[3].default
  ), l = q(
    s,
    t,
    /*$$scope*/
    t[2],
    null
  );
  return {
    c() {
      e = k("button"), l && l.c(), _(e, "class", r = Ae(`intent-${/*intent*/
      t[0]}`) + " svelte-1rmxk7q"), e.disabled = /*disabled*/
      t[1];
    },
    m(c, a) {
      p(c, e, a), l && l.m(e, null), n = !0, i || (o = we(
        e,
        "click",
        /*click_handler*/
        t[4]
      ), i = !0);
    },
    p(c, [a]) {
      l && l.p && (!n || a & /*$$scope*/
      4) && J(
        l,
        s,
        c,
        /*$$scope*/
        c[2],
        n ? j(
          s,
          /*$$scope*/
          c[2],
          a,
          null
        ) : V(
          /*$$scope*/
          c[2]
        ),
        null
      ), (!n || a & /*intent*/
      1 && r !== (r = Ae(`intent-${/*intent*/
      c[0]}`) + " svelte-1rmxk7q")) && _(e, "class", r), (!n || a & /*disabled*/
      2) && (e.disabled = /*disabled*/
      c[1]);
    },
    i(c) {
      n || (f(l, c), n = !0);
    },
    o(c) {
      d(l, c), n = !1;
    },
    d(c) {
      c && g(e), l && l.d(c), i = !1, o();
    }
  };
}
function zn(t, e, r) {
  let { $$slots: n = {}, $$scope: i } = e, { intent: o = "primary" } = e, { disabled: s = !1 } = e;
  function l(c) {
    Pt.call(this, t, c);
  }
  return t.$$set = (c) => {
    "intent" in c && r(0, o = c.intent), "disabled" in c && r(1, s = c.disabled), "$$scope" in c && r(2, i = c.$$scope);
  }, [o, s, i, n, l];
}
class be extends U {
  constructor(e) {
    super(), N(this, e, zn, Wn, T, { intent: 0, disabled: 1 }, Vn);
  }
}
function Xn(t) {
  x(t, "svelte-1f9z0o8", "footer.svelte-1f9z0o8{display:flex;flex-direction:column}");
}
function Zn(t) {
  let e, r;
  const n = (
    /*#slots*/
    t[1].default
  ), i = q(
    n,
    t,
    /*$$scope*/
    t[0],
    null
  );
  return {
    c() {
      e = k("footer"), i && i.c(), _(e, "class", "rcb-modal-footer svelte-1f9z0o8");
    },
    m(o, s) {
      p(o, e, s), i && i.m(e, null), r = !0;
    },
    p(o, [s]) {
      i && i.p && (!r || s & /*$$scope*/
      1) && J(
        i,
        n,
        o,
        /*$$scope*/
        o[0],
        r ? j(
          n,
          /*$$scope*/
          o[0],
          s,
          null
        ) : V(
          /*$$scope*/
          o[0]
        ),
        null
      );
    },
    i(o) {
      r || (f(i, o), r = !0);
    },
    o(o) {
      d(i, o), r = !1;
    },
    d(o) {
      o && g(e), i && i.d(o);
    }
  };
}
function er(t, e, r) {
  let { $$slots: n = {}, $$scope: i } = e;
  return t.$$set = (o) => {
    "$$scope" in o && r(0, i = o.$$scope);
  }, [i, n];
}
class ze extends U {
  constructor(e) {
    super(), N(this, e, er, Zn, T, {}, Xn);
  }
}
function tr(t) {
  x(t, "svelte-6o8e90", '.column.svelte-6o8e90{display:flex;flex-direction:column;justify-content:flex-start;gap:var(--gap, "8px");flex-grow:1}');
}
function nr(t) {
  let e, r, n;
  const i = (
    /*#slots*/
    t[2].default
  ), o = q(
    i,
    t,
    /*$$scope*/
    t[1],
    null
  );
  return {
    c() {
      e = k("div"), o && o.c(), _(e, "class", "column svelte-6o8e90"), _(e, "style", r = `--gap:${/*gutter*/
      t[0]};`);
    },
    m(s, l) {
      p(s, e, l), o && o.m(e, null), n = !0;
    },
    p(s, [l]) {
      o && o.p && (!n || l & /*$$scope*/
      2) && J(
        o,
        i,
        s,
        /*$$scope*/
        s[1],
        n ? j(
          i,
          /*$$scope*/
          s[1],
          l,
          null
        ) : V(
          /*$$scope*/
          s[1]
        ),
        null
      ), (!n || l & /*gutter*/
      1 && r !== (r = `--gap:${/*gutter*/
      s[0]};`)) && _(e, "style", r);
    },
    i(s) {
      n || (f(o, s), n = !0);
    },
    o(s) {
      d(o, s), n = !1;
    },
    d(s) {
      s && g(e), o && o.d(s);
    }
  };
}
function rr(t, e, r) {
  let { $$slots: n = {}, $$scope: i } = e, { gutter: o = "8px" } = e;
  return t.$$set = (s) => {
    "gutter" in s && r(0, o = s.gutter), "$$scope" in s && r(1, i = s.$$scope);
  }, [o, i, n];
}
class ye extends U {
  constructor(e) {
    super(), N(this, e, rr, nr, T, { gutter: 0 }, tr);
  }
}
const ir = "data:image/svg+xml,%3csvg%20width='24'%20height='24'%20viewBox='0%200%2024%2024'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cg%20id='mdi_close'%3e%3cpath%20id='Vector'%20d='M19%206.41L17.59%205L12%2010.59L6.41%205L5%206.41L10.59%2012L5%2017.59L6.41%2019L12%2013.41L17.59%2019L19%2017.59L13.41%2012L19%206.41Z'%20fill='%23767676'/%3e%3c/g%3e%3c/svg%3e";
function or(t) {
  x(t, "svelte-14xreta", ".close-button.svelte-14xreta{border:none;cursor:pointer;background-color:transparent;padding:0px}");
}
function sr(t) {
  let e, r, n, i, o;
  return {
    c() {
      e = k("button"), r = k("img"), ee(r.src, n = ir) || _(r, "src", n), _(r, "alt", "close"), _(e, "class", "close-button svelte-14xreta"), e.disabled = /*disabled*/
      t[0];
    },
    m(s, l) {
      p(s, e, l), M(e, r), i || (o = we(
        e,
        "click",
        /*click_handler*/
        t[1]
      ), i = !0);
    },
    p(s, [l]) {
      l & /*disabled*/
      1 && (e.disabled = /*disabled*/
      s[0]);
    },
    i: v,
    o: v,
    d(s) {
      s && g(e), i = !1, o();
    }
  };
}
function lr(t, e, r) {
  let { disabled: n = !1 } = e;
  function i(o) {
    Pt.call(this, t, o);
  }
  return t.$$set = (o) => {
    "disabled" in o && r(0, n = o.disabled);
  }, [n, i];
}
class cr extends U {
  constructor(e) {
    super(), N(this, e, lr, sr, T, { disabled: 0 }, or);
  }
}
function ar(t) {
  x(t, "svelte-44qpq9", ".rcb-app-icon.svelte-44qpq9{width:40px;height:40px;border-radius:12px;box-shadow:0px 1px 10px 0px rgba(0, 0, 0, 0.1);margin-right:16px}.rcb-app-icon-picture-container.svelte-44qpq9{height:40px}.rcb-app-icon.loading.svelte-44qpq9{background-color:gray}");
}
function ur(t) {
  let e;
  return {
    c() {
      e = k("div"), _(e, "class", "rcb-app-icon loading svelte-44qpq9");
    },
    m(r, n) {
      p(r, e, n);
    },
    p: v,
    d(r) {
      r && g(e);
    }
  };
}
function fr(t) {
  let e, r, n, i, o, s;
  return {
    c() {
      e = k("picture"), r = k("source"), i = Q(), o = k("img"), _(r, "type", "image/webp"), on(r, n = /*srcWebp*/
      t[1]) || _(r, "srcset", n), _(o, "class", "rcb-app-icon svelte-44qpq9"), ee(o.src, s = /*src*/
      t[0]) || _(o, "src", s), _(o, "alt", "App icon"), _(e, "class", "rcb-app-icon-picture-container svelte-44qpq9");
    },
    m(l, c) {
      p(l, e, c), M(e, r), M(e, i), M(e, o);
    },
    p(l, c) {
      c & /*srcWebp*/
      2 && n !== (n = /*srcWebp*/
      l[1]) && _(r, "srcset", n), c & /*src*/
      1 && !ee(o.src, s = /*src*/
      l[0]) && _(o, "src", s);
    },
    d(l) {
      l && g(e);
    }
  };
}
function dr(t) {
  let e;
  function r(o, s) {
    return (
      /*src*/
      o[0] !== null ? fr : ur
    );
  }
  let n = r(t), i = n(t);
  return {
    c() {
      i.c(), e = te();
    },
    m(o, s) {
      i.m(o, s), p(o, e, s);
    },
    p(o, [s]) {
      n === (n = r(o)) && i ? i.p(o, s) : (i.d(1), i = n(o), i && (i.c(), i.m(e.parentNode, e)));
    },
    i: v,
    o: v,
    d(o) {
      o && g(e), i.d(o);
    }
  };
}
function mr(t, e, r) {
  let { src: n = null } = e, { srcWebp: i = null } = e;
  return t.$$set = (o) => {
    "src" in o && r(0, n = o.src), "srcWebp" in o && r(1, i = o.srcWebp);
  }, [n, i];
}
class Nt extends U {
  constructor(e) {
    super(), N(this, e, mr, dr, T, { src: 0, srcWebp: 1 }, ar);
  }
}
const Ce = (t) => `https://da08ctfrofx1b.cloudfront.net/${t}`;
function gr(t) {
  x(t, "svelte-10uf5fq", ".app-title.svelte-10uf5fq{font-weight:500;margin:8px 0;font-size:16px}.rcb-header-layout__business-info.svelte-10uf5fq{display:flex;align-items:center}");
}
function pr(t) {
  let e, r;
  return e = new Nt({}), {
    c() {
      w(e.$$.fragment);
    },
    m(n, i) {
      b(e, n, i), r = !0;
    },
    p: v,
    i(n) {
      r || (f(e.$$.fragment, n), r = !0);
    },
    o(n) {
      d(e.$$.fragment, n), r = !1;
    },
    d(n) {
      I(e, n);
    }
  };
}
function _r(t) {
  let e, r, n = (
    /*brandingInfo*/
    t[0].seller_company_name + ""
  ), i, o, s = (
    /*brandingInfo*/
    t[0].app_icon_webp !== null && /*brandingInfo*/
    t[0].app_icon !== null && at(t)
  );
  return {
    c() {
      s && s.c(), e = Q(), r = k("span"), i = L(n), _(r, "class", "app-title svelte-10uf5fq");
    },
    m(l, c) {
      s && s.m(l, c), p(l, e, c), p(l, r, c), M(r, i), o = !0;
    },
    p(l, c) {
      /*brandingInfo*/
      l[0].app_icon_webp !== null && /*brandingInfo*/
      l[0].app_icon !== null ? s ? (s.p(l, c), c & /*brandingInfo*/
      1 && f(s, 1)) : (s = at(l), s.c(), f(s, 1), s.m(e.parentNode, e)) : s && (H(), d(s, 1, 1, () => {
        s = null;
      }), K()), (!o || c & /*brandingInfo*/
      1) && n !== (n = /*brandingInfo*/
      l[0].seller_company_name + "") && ae(i, n);
    },
    i(l) {
      o || (f(s), o = !0);
    },
    o(l) {
      d(s), o = !1;
    },
    d(l) {
      l && (g(e), g(r)), s && s.d(l);
    }
  };
}
function at(t) {
  let e, r;
  return e = new Nt({
    props: {
      src: Ce(
        /*brandingInfo*/
        t[0].app_icon
      ),
      srcWebp: Ce(
        /*brandingInfo*/
        t[0].app_icon_webp
      )
    }
  }), {
    c() {
      w(e.$$.fragment);
    },
    m(n, i) {
      b(e, n, i), r = !0;
    },
    p(n, i) {
      const o = {};
      i & /*brandingInfo*/
      1 && (o.src = Ce(
        /*brandingInfo*/
        n[0].app_icon
      )), i & /*brandingInfo*/
      1 && (o.srcWebp = Ce(
        /*brandingInfo*/
        n[0].app_icon_webp
      )), e.$set(o);
    },
    i(n) {
      r || (f(e.$$.fragment, n), r = !0);
    },
    o(n) {
      d(e.$$.fragment, n), r = !1;
    },
    d(n) {
      I(e, n);
    }
  };
}
function hr(t) {
  let e, r, n, i;
  const o = [_r, pr], s = [];
  function l(c, a) {
    return (
      /*brandingInfo*/
      c[0] !== null ? 0 : 1
    );
  }
  return r = l(t), n = s[r] = o[r](t), {
    c() {
      e = k("div"), n.c(), _(e, "class", "rcb-header-layout__business-info svelte-10uf5fq");
    },
    m(c, a) {
      p(c, e, a), s[r].m(e, null), i = !0;
    },
    p(c, [a]) {
      let u = r;
      r = l(c), r === u ? s[r].p(c, a) : (H(), d(s[u], 1, 1, () => {
        s[u] = null;
      }), K(), n = s[r], n ? n.p(c, a) : (n = s[r] = o[r](c), n.c()), f(n, 1), n.m(e, null));
    },
    i(c) {
      i || (f(n), i = !0);
    },
    o(c) {
      d(n), i = !1;
    },
    d(c) {
      c && g(e), s[r].d();
    }
  };
}
function Ar(t, e, r) {
  let { brandingInfo: n = null } = e;
  return t.$$set = (i) => {
    "brandingInfo" in i && r(0, n = i.brandingInfo);
  }, [n];
}
class Ut extends U {
  constructor(e) {
    super(), N(this, e, Ar, hr, T, { brandingInfo: 0 }, gr);
  }
}
function Er(t) {
  x(t, "svelte-17puakv", ".rcb-post-purchase-header-layout.svelte-17puakv{display:flex;justify-content:space-between;align-items:center;width:100%;margin-top:-4px}");
}
function br(t) {
  let e, r, n, i, o;
  return r = new Ut({
    props: { brandingInfo: (
      /*brandingInfo*/
      t[0]
    ) }
  }), i = new cr({}), i.$on("click", function() {
    ce(
      /*onClose*/
      t[1]
    ) && t[1].apply(this, arguments);
  }), {
    c() {
      e = k("div"), w(r.$$.fragment), n = Q(), w(i.$$.fragment), _(e, "class", "rcb-post-purchase-header-layout svelte-17puakv");
    },
    m(s, l) {
      p(s, e, l), b(r, e, null), M(e, n), b(i, e, null), o = !0;
    },
    p(s, l) {
      t = s;
      const c = {};
      l & /*brandingInfo*/
      1 && (c.brandingInfo = /*brandingInfo*/
      t[0]), r.$set(c);
    },
    i(s) {
      o || (f(r.$$.fragment, s), f(i.$$.fragment, s), o = !0);
    },
    o(s) {
      d(r.$$.fragment, s), d(i.$$.fragment, s), o = !1;
    },
    d(s) {
      s && g(e), I(r), I(i);
    }
  };
}
function Ir(t) {
  let e, r;
  return e = new ue({
    props: {
      as: "header",
      $$slots: { default: [br] },
      $$scope: { ctx: t }
    }
  }), {
    c() {
      w(e.$$.fragment);
    },
    m(n, i) {
      b(e, n, i), r = !0;
    },
    p(n, [i]) {
      const o = {};
      i & /*$$scope, onClose, brandingInfo*/
      7 && (o.$$scope = { dirty: i, ctx: n }), e.$set(o);
    },
    i(n) {
      r || (f(e.$$.fragment, n), r = !0);
    },
    o(n) {
      d(e.$$.fragment, n), r = !1;
    },
    d(n) {
      I(e, n);
    }
  };
}
function wr(t, e, r) {
  let { brandingInfo: n = null } = e, { onClose: i } = e;
  return t.$$set = (o) => {
    "brandingInfo" in o && r(0, n = o.brandingInfo), "onClose" in o && r(1, i = o.onClose);
  }, [n, i];
}
class kr extends U {
  constructor(e) {
    super(), N(this, e, wr, Ir, T, { brandingInfo: 0, onClose: 1 }, Er);
  }
}
function yr(t) {
  x(t, "svelte-10pcqja", ".rcb-modal-message.svelte-10pcqja{width:100%;min-height:160px;display:flex;justify-content:center;align-items:center;flex-direction:column;text-align:center}.title.svelte-10pcqja{font-size:24px;line-height:1.25em}.subtitle.svelte-10pcqja{font-size:16px;line-height:1.25em;overflow-wrap:anywhere}");
}
const vr = (t) => ({}), ut = (t) => ({});
function $r(t) {
  let e, r, n, i, o;
  const s = (
    /*#slots*/
    t[4].default
  ), l = q(
    s,
    t,
    /*$$scope*/
    t[5],
    null
  );
  return {
    c() {
      e = k("span"), r = L(
        /*title*/
        t[2]
      ), n = Q(), i = k("span"), l && l.c(), _(e, "class", "title svelte-10pcqja"), _(i, "class", "subtitle svelte-10pcqja");
    },
    m(c, a) {
      p(c, e, a), M(e, r), p(c, n, a), p(c, i, a), l && l.m(i, null), o = !0;
    },
    p(c, a) {
      (!o || a & /*title*/
      4) && ae(
        r,
        /*title*/
        c[2]
      ), l && l.p && (!o || a & /*$$scope*/
      32) && J(
        l,
        s,
        c,
        /*$$scope*/
        c[5],
        o ? j(
          s,
          /*$$scope*/
          c[5],
          a,
          null
        ) : V(
          /*$$scope*/
          c[5]
        ),
        null
      );
    },
    i(c) {
      o || (f(l, c), o = !0);
    },
    o(c) {
      d(l, c), o = !1;
    },
    d(c) {
      c && (g(e), g(n), g(i)), l && l.d(c);
    }
  };
}
function Br(t) {
  let e, r, n;
  const i = (
    /*#slots*/
    t[4].icon
  ), o = q(
    i,
    t,
    /*$$scope*/
    t[5],
    ut
  );
  return r = new ye({
    props: {
      gutter: "16px",
      $$slots: { default: [$r] },
      $$scope: { ctx: t }
    }
  }), {
    c() {
      o && o.c(), e = Q(), w(r.$$.fragment);
    },
    m(s, l) {
      o && o.m(s, l), p(s, e, l), b(r, s, l), n = !0;
    },
    p(s, l) {
      o && o.p && (!n || l & /*$$scope*/
      32) && J(
        o,
        i,
        s,
        /*$$scope*/
        s[5],
        n ? j(
          i,
          /*$$scope*/
          s[5],
          l,
          vr
        ) : V(
          /*$$scope*/
          s[5]
        ),
        ut
      );
      const c = {};
      l & /*$$scope, title*/
      36 && (c.$$scope = { dirty: l, ctx: s }), r.$set(c);
    },
    i(s) {
      n || (f(o, s), f(r.$$.fragment, s), n = !0);
    },
    o(s) {
      d(o, s), d(r.$$.fragment, s), n = !1;
    },
    d(s) {
      s && g(e), o && o.d(s), I(r, s);
    }
  };
}
function Dr(t) {
  let e, r, n;
  return r = new ye({
    props: {
      gutter: "16px",
      $$slots: { default: [Br] },
      $$scope: { ctx: t }
    }
  }), {
    c() {
      e = k("div"), w(r.$$.fragment), _(e, "class", "rcb-modal-message svelte-10pcqja"), _(
        e,
        "data-type",
        /*type*/
        t[3]
      );
    },
    m(i, o) {
      p(i, e, o), b(r, e, null), n = !0;
    },
    p(i, o) {
      const s = {};
      o & /*$$scope, title*/
      36 && (s.$$scope = { dirty: o, ctx: i }), r.$set(s), (!n || o & /*type*/
      8) && _(
        e,
        "data-type",
        /*type*/
        i[3]
      );
    },
    i(i) {
      n || (f(r.$$.fragment, i), n = !0);
    },
    o(i) {
      d(r.$$.fragment, i), n = !1;
    },
    d(i) {
      i && g(e), I(r);
    }
  };
}
function Cr(t) {
  let e;
  return {
    c() {
      e = L("Go back to app");
    },
    m(r, n) {
      p(r, e, n);
    },
    d(r) {
      r && g(e);
    }
  };
}
function Pr(t) {
  let e, r;
  return e = new be({
    props: {
      $$slots: { default: [Cr] },
      $$scope: { ctx: t }
    }
  }), e.$on("click", function() {
    ce(
      /*onContinue*/
      t[1]
    ) && t[1].apply(this, arguments);
  }), {
    c() {
      w(e.$$.fragment);
    },
    m(n, i) {
      b(e, n, i), r = !0;
    },
    p(n, i) {
      t = n;
      const o = {};
      i & /*$$scope*/
      32 && (o.$$scope = { dirty: i, ctx: t }), e.$set(o);
    },
    i(n) {
      r || (f(e.$$.fragment, n), r = !0);
    },
    o(n) {
      d(e.$$.fragment, n), r = !1;
    },
    d(n) {
      I(e, n);
    }
  };
}
function Mr(t) {
  let e, r, n, i, o, s;
  return e = new kr({
    props: {
      brandingInfo: (
        /*brandingInfo*/
        t[0]
      ),
      onClose: (
        /*onContinue*/
        t[1]
      )
    }
  }), n = new ue({
    props: {
      $$slots: { default: [Dr] },
      $$scope: { ctx: t }
    }
  }), o = new ze({
    props: {
      $$slots: { default: [Pr] },
      $$scope: { ctx: t }
    }
  }), {
    c() {
      w(e.$$.fragment), r = Q(), w(n.$$.fragment), i = Q(), w(o.$$.fragment);
    },
    m(l, c) {
      b(e, l, c), p(l, r, c), b(n, l, c), p(l, i, c), b(o, l, c), s = !0;
    },
    p(l, c) {
      const a = {};
      c & /*brandingInfo*/
      1 && (a.brandingInfo = /*brandingInfo*/
      l[0]), c & /*onContinue*/
      2 && (a.onClose = /*onContinue*/
      l[1]), e.$set(a);
      const u = {};
      c & /*$$scope, type, title*/
      44 && (u.$$scope = { dirty: c, ctx: l }), n.$set(u);
      const m = {};
      c & /*$$scope, onContinue*/
      34 && (m.$$scope = { dirty: c, ctx: l }), o.$set(m);
    },
    i(l) {
      s || (f(e.$$.fragment, l), f(n.$$.fragment, l), f(o.$$.fragment, l), s = !0);
    },
    o(l) {
      d(e.$$.fragment, l), d(n.$$.fragment, l), d(o.$$.fragment, l), s = !1;
    },
    d(l) {
      l && (g(r), g(i)), I(e, l), I(n, l), I(o, l);
    }
  };
}
function Qr(t) {
  let e, r;
  return e = new ye({
    props: {
      gutter: "32px",
      $$slots: { default: [Mr] },
      $$scope: { ctx: t }
    }
  }), {
    c() {
      w(e.$$.fragment);
    },
    m(n, i) {
      b(e, n, i), r = !0;
    },
    p(n, [i]) {
      const o = {};
      i & /*$$scope, onContinue, type, title, brandingInfo*/
      47 && (o.$$scope = { dirty: i, ctx: n }), e.$set(o);
    },
    i(n) {
      r || (f(e.$$.fragment, n), r = !0);
    },
    o(n) {
      d(e.$$.fragment, n), r = !1;
    },
    d(n) {
      I(e, n);
    }
  };
}
function Tr(t, e, r) {
  let { $$slots: n = {}, $$scope: i } = e, { brandingInfo: o = null } = e, { onContinue: s } = e, { title: l } = e, { type: c } = e;
  return t.$$set = (a) => {
    "brandingInfo" in a && r(0, o = a.brandingInfo), "onContinue" in a && r(1, s = a.onContinue), "title" in a && r(2, l = a.title), "type" in a && r(3, c = a.type), "$$scope" in a && r(5, i = a.$$scope);
  }, [o, s, l, c, n, i];
}
class Rt extends U {
  constructor(e) {
    super(), N(
      this,
      e,
      Tr,
      Qr,
      T,
      {
        brandingInfo: 0,
        onContinue: 1,
        title: 2,
        type: 3
      },
      yr
    );
  }
}
function ft(t) {
  let e, r, n, i, o;
  return {
    c() {
      e = L("If this error persists, please contact "), r = k("a"), n = L(
        /*supportEmail*/
        t[1]
      ), o = L("."), _(r, "href", i = "mailto:" + /*supportEmail*/
      t[1]);
    },
    m(s, l) {
      p(s, e, l), p(s, r, l), M(r, n), p(s, o, l);
    },
    p(s, l) {
      l & /*supportEmail*/
      2 && ae(
        n,
        /*supportEmail*/
        s[1]
      ), l & /*supportEmail*/
      2 && i !== (i = "mailto:" + /*supportEmail*/
      s[1]) && _(r, "href", i);
    },
    d(s) {
      s && (g(e), g(r), g(o));
    }
  };
}
function Nr(t) {
  let e = (
    /*getErrorMessage*/
    t[3]() + ""
  ), r, n, i, o = (
    /*supportEmail*/
    t[1] && ft(t)
  );
  return {
    c() {
      r = L(e), n = Q(), o && o.c(), i = te();
    },
    m(s, l) {
      p(s, r, l), p(s, n, l), o && o.m(s, l), p(s, i, l);
    },
    p(s, l) {
      /*supportEmail*/
      s[1] ? o ? o.p(s, l) : (o = ft(s), o.c(), o.m(i.parentNode, i)) : o && (o.d(1), o = null);
    },
    d(s) {
      s && (g(r), g(n), g(i)), o && o.d(s);
    }
  };
}
function Ur(t) {
  let e, r;
  return e = new Jn({ props: { slot: "icon" } }), {
    c() {
      w(e.$$.fragment);
    },
    m(n, i) {
      b(e, n, i), r = !0;
    },
    p: v,
    i(n) {
      r || (f(e.$$.fragment, n), r = !0);
    },
    o(n) {
      d(e.$$.fragment, n), r = !1;
    },
    d(n) {
      I(e, n);
    }
  };
}
function Rr(t) {
  let e, r;
  return e = new Rt({
    props: {
      title: (
        /*getErrorTitle*/
        t[4]()
      ),
      brandingInfo: (
        /*brandingInfo*/
        t[0]
      ),
      onContinue: (
        /*onContinue*/
        t[2]
      ),
      type: "error",
      $$slots: {
        icon: [Ur],
        default: [Nr]
      },
      $$scope: { ctx: t }
    }
  }), {
    c() {
      w(e.$$.fragment);
    },
    m(n, i) {
      b(e, n, i), r = !0;
    },
    p(n, [i]) {
      const o = {};
      i & /*brandingInfo*/
      1 && (o.brandingInfo = /*brandingInfo*/
      n[0]), i & /*onContinue*/
      4 && (o.onContinue = /*onContinue*/
      n[2]), i & /*$$scope, supportEmail*/
      66 && (o.$$scope = { dirty: i, ctx: n }), e.$set(o);
    },
    i(n) {
      r || (f(e.$$.fragment, n), r = !0);
    },
    o(n) {
      d(e.$$.fragment, n), r = !1;
    },
    d(n) {
      I(e, n);
    }
  };
}
function Sr(t, e, r) {
  let { brandingInfo: n = null } = e, { lastError: i } = e, { supportEmail: o = null } = e, { onContinue: s } = e;
  Se(() => {
    G.errorLog(`Displayed error: ${O[i.errorCode]}. Message: ${i.message ?? "None"}. Underlying error: ${i.underlyingErrorMessage ?? "None"}`);
  });
  function l() {
    switch (i.errorCode) {
      case O.UnknownError:
        return "An unknown error occurred.";
      case O.ErrorSettingUpPurchase:
        return "Purchase not started due to an error.";
      case O.ErrorChargingPayment:
        return "Payment failed.";
      case O.NetworkError:
        return "Network error. Please check your internet connection.";
      case O.StripeError:
        return i.message;
      case O.MissingEmailError:
        return "Email is required to complete the purchase.";
      case O.AlreadySubscribedError:
        return "You are already subscribed to this product.";
    }
    return i.message;
  }
  function c() {
    switch (i.errorCode) {
      case O.AlreadySubscribedError:
        return "Already subscribed";
      default:
        return "Something went wrong";
    }
  }
  return t.$$set = (a) => {
    "brandingInfo" in a && r(0, n = a.brandingInfo), "lastError" in a && r(5, i = a.lastError), "supportEmail" in a && r(1, o = a.supportEmail), "onContinue" in a && r(2, s = a.onContinue);
  }, [
    n,
    o,
    s,
    l,
    c,
    i
  ];
}
class Or extends U {
  constructor(e) {
    super(), N(this, e, Sr, Rr, T, {
      brandingInfo: 0,
      lastError: 5,
      supportEmail: 1,
      onContinue: 2
    });
  }
}
const Lr = "data:image/svg+xml,%3csvg%20width='124'%20height='124'%20viewBox='0%200%20124%20124'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3ccircle%20cx='62'%20cy='62'%20r='62'%20fill='%23576CDB'/%3e%3crect%20x='44.1116'%20y='56'%20width='27.5'%20height='11'%20transform='rotate(45%2044.1116%2056)'%20fill='white'/%3e%3crect%20x='79.1133'%20y='44.334'%20width='11'%20height='44'%20transform='rotate(45%2079.1133%2044.334)'%20fill='white'/%3e%3c/svg%3e";
function xr(t) {
  x(t, "svelte-1609h93", "img.svelte-1609h93{width:124px;height:124px;margin:0 auto}");
}
function Fr(t) {
  let e, r;
  return {
    c() {
      e = k("img"), ee(e.src, r = Lr) || _(e, "src", r), _(e, "alt", "icon"), _(e, "class", "rcb-ui-asset-icon svelte-1609h93");
    },
    m(n, i) {
      p(n, e, i);
    },
    p: v,
    i: v,
    o: v,
    d(n) {
      n && g(e);
    }
  };
}
class Gr extends U {
  constructor(e) {
    super(), N(this, e, null, Fr, T, {}, xr);
  }
}
function Yr(t) {
  let e;
  return {
    c() {
      e = L("Your plan is now active.");
    },
    m(r, n) {
      p(r, e, n);
    },
    d(r) {
      r && g(e);
    }
  };
}
function Hr(t) {
  let e, r;
  return e = new Gr({ props: { slot: "icon" } }), {
    c() {
      w(e.$$.fragment);
    },
    m(n, i) {
      b(e, n, i), r = !0;
    },
    p: v,
    i(n) {
      r || (f(e.$$.fragment, n), r = !0);
    },
    o(n) {
      d(e.$$.fragment, n), r = !1;
    },
    d(n) {
      I(e, n);
    }
  };
}
function Kr(t) {
  let e, r;
  return e = new Rt({
    props: {
      type: "success",
      title: "Purchase successful",
      brandingInfo: (
        /*brandingInfo*/
        t[0]
      ),
      onContinue: (
        /*onContinue*/
        t[1]
      ),
      $$slots: {
        icon: [Hr],
        default: [Yr]
      },
      $$scope: { ctx: t }
    }
  }), {
    c() {
      w(e.$$.fragment);
    },
    m(n, i) {
      b(e, n, i), r = !0;
    },
    p(n, [i]) {
      const o = {};
      i & /*brandingInfo*/
      1 && (o.brandingInfo = /*brandingInfo*/
      n[0]), i & /*onContinue*/
      2 && (o.onContinue = /*onContinue*/
      n[1]), i & /*$$scope*/
      4 && (o.$$scope = { dirty: i, ctx: n }), e.$set(o);
    },
    i(n) {
      r || (f(e.$$.fragment, n), r = !0);
    },
    o(n) {
      d(e.$$.fragment, n), r = !1;
    },
    d(n) {
      I(e, n);
    }
  };
}
function qr(t, e, r) {
  let { brandingInfo: n = null } = e, { onContinue: i } = e;
  return t.$$set = (o) => {
    "brandingInfo" in o && r(0, n = o.brandingInfo), "onContinue" in o && r(1, i = o.onContinue);
  }, [n, i];
}
class jr extends U {
  constructor(e) {
    super(), N(this, e, qr, Kr, T, { brandingInfo: 0, onContinue: 1 });
  }
}
function Jr(t, e, r, n, i = {}) {
  const o = r.create(e, i);
  return o.mount(t), o.on("change", (s) => n("change", s)), o.on("ready", (s) => n("ready", s)), o.on("focus", (s) => n("focus", s)), o.on("blur", (s) => n("blur", s)), o.on("escape", (s) => n("escape", s)), o.on("click", (s) => n("click", s)), o.on("loaderror", (s) => n("loaderror", s)), o.on("loaderstart", (s) => n("loaderstart", s)), o.on("networkschange", (s) => n("networkschange", s)), o;
}
const Vr = typeof window > "u";
function Wr(t) {
  if (!Vr)
    return t.registerAppInfo({
      name: "svelte-stripe-js",
      url: "https://svelte-stripe-js.vercel.app"
    });
}
function zr(t) {
  let e;
  return {
    c() {
      e = k("div");
    },
    m(r, n) {
      p(r, e, n), t[6](e);
    },
    p: v,
    i: v,
    o: v,
    d(r) {
      r && g(e), t[6](null);
    }
  };
}
function Xr(t, e, r) {
  let n, i;
  const o = hn(), { elements: s } = En("stripe");
  let { options: l = void 0 } = e;
  Se(() => (n = Jr(i, "payment", s, o, l), () => n.destroy()));
  function c() {
    n.blur();
  }
  function a() {
    n.clear();
  }
  function u() {
    n.destroy();
  }
  function m() {
    n.focus();
  }
  function h(y) {
    Ue[y ? "unshift" : "push"](() => {
      i = y, r(0, i);
    });
  }
  return t.$$set = (y) => {
    "options" in y && r(1, l = y.options);
  }, [i, l, c, a, u, m, h];
}
class Zr extends U {
  constructor(e) {
    super(), N(this, e, Xr, zr, T, {
      options: 1,
      blur: 2,
      clear: 3,
      destroy: 4,
      focus: 5
    });
  }
  get blur() {
    return this.$$.ctx[2];
  }
  get clear() {
    return this.$$.ctx[3];
  }
  get destroy() {
    return this.$$.ctx[4];
  }
  get focus() {
    return this.$$.ctx[5];
  }
}
function dt(t) {
  let e;
  const r = (
    /*#slots*/
    t[15].default
  ), n = q(
    r,
    t,
    /*$$scope*/
    t[14],
    null
  );
  return {
    c() {
      n && n.c();
    },
    m(i, o) {
      n && n.m(i, o), e = !0;
    },
    p(i, o) {
      n && n.p && (!e || o & /*$$scope*/
      16384) && J(
        n,
        r,
        i,
        /*$$scope*/
        i[14],
        e ? j(
          r,
          /*$$scope*/
          i[14],
          o,
          null
        ) : V(
          /*$$scope*/
          i[14]
        ),
        null
      );
    },
    i(i) {
      e || (f(n, i), e = !0);
    },
    o(i) {
      d(n, i), e = !1;
    },
    d(i) {
      n && n.d(i);
    }
  };
}
function ei(t) {
  let e, r, n = (
    /*stripe*/
    t[1] && /*elements*/
    t[0] && dt(t)
  );
  return {
    c() {
      n && n.c(), e = te();
    },
    m(i, o) {
      n && n.m(i, o), p(i, e, o), r = !0;
    },
    p(i, [o]) {
      /*stripe*/
      i[1] && /*elements*/
      i[0] ? n ? (n.p(i, o), o & /*stripe, elements*/
      3 && f(n, 1)) : (n = dt(i), n.c(), f(n, 1), n.m(e.parentNode, e)) : n && (H(), d(n, 1, 1, () => {
        n = null;
      }), K());
    },
    i(i) {
      r || (f(n), r = !0);
    },
    o(i) {
      d(n), r = !1;
    },
    d(i) {
      i && g(e), n && n.d(i);
    }
  };
}
function ti(t, e, r) {
  let n, { $$slots: i = {}, $$scope: o } = e, { stripe: s } = e, { mode: l = void 0 } = e, { theme: c = "stripe" } = e, { variables: a = {} } = e, { rules: u = {} } = e, { labels: m = "above" } = e, { loader: h = "auto" } = e, { fonts: y = [] } = e, { locale: E = "auto" } = e, { currency: B = void 0 } = e, { amount: A = void 0 } = e, { clientSecret: $ = void 0 } = e, { elements: R = null } = e;
  return t.$$set = (C) => {
    "stripe" in C && r(1, s = C.stripe), "mode" in C && r(2, l = C.mode), "theme" in C && r(3, c = C.theme), "variables" in C && r(4, a = C.variables), "rules" in C && r(5, u = C.rules), "labels" in C && r(6, m = C.labels), "loader" in C && r(7, h = C.loader), "fonts" in C && r(8, y = C.fonts), "locale" in C && r(9, E = C.locale), "currency" in C && r(10, B = C.currency), "amount" in C && r(11, A = C.amount), "clientSecret" in C && r(12, $ = C.clientSecret), "elements" in C && r(0, R = C.elements), "$$scope" in C && r(14, o = C.$$scope);
  }, t.$$.update = () => {
    t.$$.dirty & /*theme, variables, rules, labels*/
    120 && r(13, n = { theme: c, variables: a, rules: u, labels: m }), t.$$.dirty & /*stripe, elements, mode, currency, amount, appearance, clientSecret, fonts, loader, locale*/
    16263 && s && !R && (r(0, R = s.elements({
      mode: l,
      currency: B,
      amount: A,
      appearance: n,
      clientSecret: $,
      fonts: y,
      loader: h,
      locale: E
    })), Wr(s), An("stripe", { stripe: s, elements: R })), t.$$.dirty & /*elements, appearance, locale*/
    8705 && R && R.update({ appearance: n, locale: E });
  }, [
    R,
    s,
    l,
    c,
    a,
    u,
    m,
    h,
    y,
    E,
    B,
    A,
    $,
    n,
    o,
    i
  ];
}
class ni extends U {
  constructor(e) {
    super(), N(this, e, ti, ei, T, {
      stripe: 1,
      mode: 2,
      theme: 3,
      variables: 4,
      rules: 5,
      labels: 6,
      loader: 7,
      fonts: 8,
      locale: 9,
      currency: 10,
      amount: 11,
      clientSecret: 12,
      elements: 0
    });
  }
}
var St = "https://js.stripe.com/v3", ri = /^https:\/\/js\.stripe\.com\/v3\/?(\?.*)?$/, mt = "loadStripe.setLoadParameters was called but an existing Stripe.js script already exists in the document; existing script parameters will be used", ii = function() {
  for (var e = document.querySelectorAll('script[src^="'.concat(St, '"]')), r = 0; r < e.length; r++) {
    var n = e[r];
    if (ri.test(n.src))
      return n;
  }
  return null;
}, gt = function(e) {
  var r = e && !e.advancedFraudSignals ? "?advancedFraudSignals=false" : "", n = document.createElement("script");
  n.src = "".concat(St).concat(r);
  var i = document.head || document.body;
  if (!i)
    throw new Error("Expected document.body not to be null. Stripe.js requires a <body> element.");
  return i.appendChild(n), n;
}, oi = function(e, r) {
  !e || !e._registerWrapper || e._registerWrapper({
    name: "stripe-js",
    version: "2.4.0",
    startTime: r
  });
}, de = null, Pe = null, Me = null, si = function(e) {
  return function() {
    e(new Error("Failed to load Stripe.js"));
  };
}, li = function(e, r) {
  return function() {
    window.Stripe ? e(window.Stripe) : r(new Error("Stripe.js not available"));
  };
}, ci = function(e) {
  return de !== null ? de : (de = new Promise(function(r, n) {
    if (typeof window > "u" || typeof document > "u") {
      r(null);
      return;
    }
    if (window.Stripe && e && console.warn(mt), window.Stripe) {
      r(window.Stripe);
      return;
    }
    try {
      var i = ii();
      if (i && e)
        console.warn(mt);
      else if (!i)
        i = gt(e);
      else if (i && Me !== null && Pe !== null) {
        var o;
        i.removeEventListener("load", Me), i.removeEventListener("error", Pe), (o = i.parentNode) === null || o === void 0 || o.removeChild(i), i = gt(e);
      }
      Me = li(r, n), Pe = si(n), i.addEventListener("load", Me), i.addEventListener("error", Pe);
    } catch (s) {
      n(s);
      return;
    }
  }), de.catch(function(r) {
    return de = null, Promise.reject(r);
  }));
}, ai = function(e, r, n) {
  if (e === null)
    return null;
  var i = e.apply(void 0, r);
  return oi(i, n), i;
}, me, Ot = !1, Lt = function() {
  return me || (me = ci(null).catch(function(e) {
    return me = null, Promise.reject(e);
  }), me);
};
Promise.resolve().then(function() {
  return Lt();
}).catch(function(t) {
  Ot || console.warn(t);
});
var ui = function() {
  for (var e = arguments.length, r = new Array(e), n = 0; n < e; n++)
    r[n] = arguments[n];
  Ot = !0;
  var i = Date.now();
  return Lt().then(function(o) {
    return ai(o, r, i);
  });
};
function fi(t) {
  x(t, "svelte-1xe711j", ".rcb-header-layout.svelte-1xe711j{display:flex;justify-content:space-between;align-items:center;width:100%;font-size:24px;margin:0;font-weight:500}");
}
function di(t) {
  let e, r;
  const n = (
    /*#slots*/
    t[0].default
  ), i = q(
    n,
    t,
    /*$$scope*/
    t[1],
    null
  );
  return {
    c() {
      e = k("div"), i && i.c(), _(e, "class", "rcb-header-layout svelte-1xe711j");
    },
    m(o, s) {
      p(o, e, s), i && i.m(e, null), r = !0;
    },
    p(o, s) {
      i && i.p && (!r || s & /*$$scope*/
      2) && J(
        i,
        n,
        o,
        /*$$scope*/
        o[1],
        r ? j(
          n,
          /*$$scope*/
          o[1],
          s,
          null
        ) : V(
          /*$$scope*/
          o[1]
        ),
        null
      );
    },
    i(o) {
      r || (f(i, o), r = !0);
    },
    o(o) {
      d(i, o), r = !1;
    },
    d(o) {
      o && g(e), i && i.d(o);
    }
  };
}
function mi(t) {
  let e, r;
  return e = new ue({
    props: {
      as: "header",
      $$slots: { default: [di] },
      $$scope: { ctx: t }
    }
  }), {
    c() {
      w(e.$$.fragment);
    },
    m(n, i) {
      b(e, n, i), r = !0;
    },
    p(n, [i]) {
      const o = {};
      i & /*$$scope*/
      2 && (o.$$scope = { dirty: i, ctx: n }), e.$set(o);
    },
    i(n) {
      r || (f(e.$$.fragment, n), r = !0);
    },
    o(n) {
      d(e.$$.fragment, n), r = !1;
    },
    d(n) {
      I(e, n);
    }
  };
}
function gi(t, e, r) {
  let { $$slots: n = {}, $$scope: i } = e;
  return t.$$set = (o) => {
    "$$scope" in o && r(1, i = o.$$scope);
  }, [n, i];
}
class Xe extends U {
  constructor(e) {
    super(), N(this, e, gi, mi, T, {}, fi);
  }
}
const pi = "data:image/svg+xml,%3csvg%20width='24'%20height='24'%20viewBox='0%200%2024%2024'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M18%208H17V6C17%203.24%2014.76%201%2012%201C9.24%201%207%203.24%207%206V8H6C4.9%208%204%208.9%204%2010V20C4%2021.1%204.9%2022%206%2022H18C19.1%2022%2020%2021.1%2020%2020V10C20%208.9%2019.1%208%2018%208ZM12%2017C10.9%2017%2010%2016.1%2010%2015C10%2013.9%2010.9%2013%2012%2013C13.1%2013%2014%2013.9%2014%2015C14%2016.1%2013.1%2017%2012%2017ZM15.1%208H8.9V6C8.9%204.29%2010.29%202.9%2012%202.9C13.71%202.9%2015.1%204.29%2015.1%206V8Z'%20fill='%2311D483'/%3e%3c/svg%3e";
function _i(t) {
  let e, r;
  return {
    c() {
      e = k("img"), ee(e.src, r = pi) || _(e, "src", r), _(e, "alt", "icon"), _(e, "class", "rcb-ui-asset-icon");
    },
    m(n, i) {
      p(n, e, i);
    },
    p: v,
    i: v,
    o: v,
    d(n) {
      n && g(e);
    }
  };
}
class hi extends U {
  constructor(e) {
    super(), N(this, e, null, _i, T, {});
  }
}
const pe = {
  error: "#f2545b",
  warning: "#f4e971",
  focus: "#000080",
  "grey-text-dark": "#000000",
  "grey-text-light": "#767676",
  "grey-ui-dark": "#dfdfdf",
  white: "#ffffff"
};
function Ai(t) {
  x(t, "svelte-rjmul6", `.processing.svelte-rjmul6{width:12px;aspect-ratio:1;border-radius:50%;animation:svelte-rjmul6-l5 1.5s infinite linear}@keyframes svelte-rjmul6-l5{0%{box-shadow:20px 0 #fff2,
        -20px 0 #fff2;background:#fff2}25%{box-shadow:20px 0 #fff2,
        -20px 0 #ffff;background:#fff2}50%{box-shadow:20px 0 #fff2,
        -20px 0 #fff2;background:#ffff}75%{box-shadow:20px 0 #ffff,
        -20px 0 #fff2;background:#fff2}100%{box-shadow:20px 0 #fff2,
        -20px 0 #fff2;background:#fff2}}`);
}
function Ei(t) {
  let e;
  return {
    c() {
      e = k("div"), _(e, "class", "processing svelte-rjmul6");
    },
    m(r, n) {
      p(r, e, n);
    },
    p: v,
    i: v,
    o: v,
    d(r) {
      r && g(e);
    }
  };
}
class xt extends U {
  constructor(e) {
    super(), N(this, e, null, Ei, T, {}, Ai);
  }
}
function bi(t) {
  x(t, "svelte-1wxt892", ".rcb-stripe-elements-container.svelte-1wxt892{width:100%;margin-top:32px;margin-bottom:24px}");
}
function Ii(t) {
  let e, r;
  return e = new We({}), {
    c() {
      w(e.$$.fragment);
    },
    m(n, i) {
      b(e, n, i), r = !0;
    },
    p: v,
    i(n) {
      r || (f(e.$$.fragment, n), r = !0);
    },
    o(n) {
      d(e.$$.fragment, n), r = !1;
    },
    d(n) {
      I(e, n);
    }
  };
}
function wi(t) {
  let e, r, n, i, o, s;
  function l(a) {
    t[9](a);
  }
  let c = {
    stripe: (
      /*stripe*/
      t[3]
    ),
    clientSecret: (
      /*clientSecret*/
      t[4]
    ),
    loader: "always",
    theme: "stripe",
    variables: {
      borderRadius: "12px",
      fontSizeBase: "16px",
      fontSizeSm: "16px",
      spacingGridRow: "16px",
      colorText: pe["grey-text-dark"],
      focusBoxShadow: "none",
      colorDanger: pe.error
    },
    rules: {
      ".Input": {
        boxShadow: "none",
        border: `2px solid ${pe["grey-ui-dark"]}`
      },
      ".Input:focus": {
        border: `2px solid ${pe.focus}`,
        outline: "none"
      },
      ".Label": {
        marginBottom: "8px",
        fontWeight: "500",
        lineHeight: "22px"
      },
      ".Input--invalid": { boxShadow: "none" }
    },
    $$slots: { default: [Mi] },
    $$scope: { ctx: t }
  };
  return (
    /*elements*/
    t[2] !== void 0 && (c.elements = /*elements*/
    t[2]), r = new ni({ props: c }), Ue.push(() => vn(r, "elements", l)), {
      c() {
        e = k("form"), w(r.$$.fragment);
      },
      m(a, u) {
        p(a, e, u), b(r, e, null), i = !0, o || (s = we(e, "submit", Ct(
          /*handleContinue*/
          t[5]
        )), o = !0);
      },
      p(a, u) {
        const m = {};
        u & /*stripe*/
        8 && (m.stripe = /*stripe*/
        a[3]), u & /*$$scope, processing, onClose*/
        2051 && (m.$$scope = { dirty: u, ctx: a }), !n && u & /*elements*/
        4 && (n = !0, m.elements = /*elements*/
        a[2], wn(() => n = !1)), r.$set(m);
      },
      i(a) {
        i || (f(r.$$.fragment, a), i = !0);
      },
      o(a) {
        d(r.$$.fragment, a), i = !1;
      },
      d(a) {
        a && g(e), I(r), o = !1, s();
      }
    }
  );
}
function ki(t) {
  let e, r, n, i;
  return n = new hi({}), {
    c() {
      e = k("div"), e.textContent = "Secure Checkout", r = Q(), w(n.$$.fragment);
    },
    m(o, s) {
      p(o, e, s), p(o, r, s), b(n, o, s), i = !0;
    },
    p: v,
    i(o) {
      i || (f(n.$$.fragment, o), i = !0);
    },
    o(o) {
      d(n.$$.fragment, o), i = !1;
    },
    d(o) {
      o && (g(e), g(r)), I(n, o);
    }
  };
}
function yi(t) {
  let e, r, n;
  return r = new Zr({}), {
    c() {
      e = k("div"), w(r.$$.fragment), _(e, "class", "rcb-stripe-elements-container svelte-1wxt892");
    },
    m(i, o) {
      p(i, e, o), b(r, e, null), n = !0;
    },
    p: v,
    i(i) {
      n || (f(r.$$.fragment, i), n = !0);
    },
    o(i) {
      d(r.$$.fragment, i), n = !1;
    },
    d(i) {
      i && g(e), I(r);
    }
  };
}
function vi(t) {
  let e;
  return {
    c() {
      e = L("Pay");
    },
    m(r, n) {
      p(r, e, n);
    },
    i: v,
    o: v,
    d(r) {
      r && g(e);
    }
  };
}
function $i(t) {
  let e, r;
  return e = new xt({}), {
    c() {
      w(e.$$.fragment);
    },
    m(n, i) {
      b(e, n, i), r = !0;
    },
    i(n) {
      r || (f(e.$$.fragment, n), r = !0);
    },
    o(n) {
      d(e.$$.fragment, n), r = !1;
    },
    d(n) {
      I(e, n);
    }
  };
}
function Bi(t) {
  let e, r, n, i;
  const o = [$i, vi], s = [];
  function l(c, a) {
    return (
      /*processing*/
      c[0] ? 0 : 1
    );
  }
  return e = l(t), r = s[e] = o[e](t), {
    c() {
      r.c(), n = te();
    },
    m(c, a) {
      s[e].m(c, a), p(c, n, a), i = !0;
    },
    p(c, a) {
      let u = e;
      e = l(c), e !== u && (H(), d(s[u], 1, 1, () => {
        s[u] = null;
      }), K(), r = s[e], r || (r = s[e] = o[e](c), r.c()), f(r, 1), r.m(n.parentNode, n));
    },
    i(c) {
      i || (f(r), i = !0);
    },
    o(c) {
      d(r), i = !1;
    },
    d(c) {
      c && g(n), s[e].d(c);
    }
  };
}
function Di(t) {
  let e;
  return {
    c() {
      e = L("Close");
    },
    m(r, n) {
      p(r, e, n);
    },
    d(r) {
      r && g(e);
    }
  };
}
function Ci(t) {
  let e, r, n, i;
  return e = new be({
    props: {
      disabled: (
        /*processing*/
        t[0]
      ),
      $$slots: { default: [Bi] },
      $$scope: { ctx: t }
    }
  }), n = new be({
    props: {
      disabled: (
        /*processing*/
        t[0]
      ),
      intent: "secondary",
      $$slots: { default: [Di] },
      $$scope: { ctx: t }
    }
  }), n.$on("click", function() {
    ce(
      /*onClose*/
      t[1]
    ) && t[1].apply(this, arguments);
  }), {
    c() {
      w(e.$$.fragment), r = Q(), w(n.$$.fragment);
    },
    m(o, s) {
      b(e, o, s), p(o, r, s), b(n, o, s), i = !0;
    },
    p(o, s) {
      t = o;
      const l = {};
      s & /*processing*/
      1 && (l.disabled = /*processing*/
      t[0]), s & /*$$scope, processing*/
      2049 && (l.$$scope = { dirty: s, ctx: t }), e.$set(l);
      const c = {};
      s & /*processing*/
      1 && (c.disabled = /*processing*/
      t[0]), s & /*$$scope*/
      2048 && (c.$$scope = { dirty: s, ctx: t }), n.$set(c);
    },
    i(o) {
      i || (f(e.$$.fragment, o), f(n.$$.fragment, o), i = !0);
    },
    o(o) {
      d(e.$$.fragment, o), d(n.$$.fragment, o), i = !1;
    },
    d(o) {
      o && g(r), I(e, o), I(n, o);
    }
  };
}
function Pi(t) {
  let e, r;
  return e = new ye({
    props: {
      $$slots: { default: [Ci] },
      $$scope: { ctx: t }
    }
  }), {
    c() {
      w(e.$$.fragment);
    },
    m(n, i) {
      b(e, n, i), r = !0;
    },
    p(n, i) {
      const o = {};
      i & /*$$scope, processing, onClose*/
      2051 && (o.$$scope = { dirty: i, ctx: n }), e.$set(o);
    },
    i(n) {
      r || (f(e.$$.fragment, n), r = !0);
    },
    o(n) {
      d(e.$$.fragment, n), r = !1;
    },
    d(n) {
      I(e, n);
    }
  };
}
function Mi(t) {
  let e, r, n, i, o, s;
  return e = new Xe({
    props: {
      $$slots: { default: [ki] },
      $$scope: { ctx: t }
    }
  }), n = new ue({
    props: {
      $$slots: { default: [yi] },
      $$scope: { ctx: t }
    }
  }), o = new ze({
    props: {
      $$slots: { default: [Pi] },
      $$scope: { ctx: t }
    }
  }), {
    c() {
      w(e.$$.fragment), r = Q(), w(n.$$.fragment), i = Q(), w(o.$$.fragment);
    },
    m(l, c) {
      b(e, l, c), p(l, r, c), b(n, l, c), p(l, i, c), b(o, l, c), s = !0;
    },
    p(l, c) {
      const a = {};
      c & /*$$scope*/
      2048 && (a.$$scope = { dirty: c, ctx: l }), e.$set(a);
      const u = {};
      c & /*$$scope*/
      2048 && (u.$$scope = { dirty: c, ctx: l }), n.$set(u);
      const m = {};
      c & /*$$scope, processing, onClose*/
      2051 && (m.$$scope = { dirty: c, ctx: l }), o.$set(m);
    },
    i(l) {
      s || (f(e.$$.fragment, l), f(n.$$.fragment, l), f(o.$$.fragment, l), s = !0);
    },
    o(l) {
      d(e.$$.fragment, l), d(n.$$.fragment, l), d(o.$$.fragment, l), s = !1;
    },
    d(l) {
      l && (g(r), g(i)), I(e, l), I(n, l), I(o, l);
    }
  };
}
function Qi(t) {
  let e, r, n, i;
  const o = [wi, Ii], s = [];
  function l(c, a) {
    return (
      /*stripe*/
      c[3] && /*clientSecret*/
      c[4] ? 0 : 1
    );
  }
  return r = l(t), n = s[r] = o[r](t), {
    c() {
      e = k("div"), n.c();
    },
    m(c, a) {
      p(c, e, a), s[r].m(e, null), i = !0;
    },
    p(c, [a]) {
      let u = r;
      r = l(c), r === u ? s[r].p(c, a) : (H(), d(s[u], 1, 1, () => {
        s[u] = null;
      }), K(), n = s[r], n ? n.p(c, a) : (n = s[r] = o[r](c), n.c()), f(n, 1), n.m(e, null));
    },
    i(c) {
      i || (f(n), i = !0);
    },
    o(c) {
      d(n), i = !1;
    },
    d(c) {
      c && g(e), s[r].d();
    }
  };
}
function Ti(t, e, r) {
  let { onClose: n } = e, { onContinue: i } = e, { onError: o } = e, { paymentInfoCollectionMetadata: s } = e, { processing: l = !1 } = e;
  const c = s.data.client_secret;
  let a = null, u, m;
  Se(async () => {
    const E = s.data.publishable_api_key, B = s.data.stripe_account_id;
    if (!E || !B)
      throw new Error("Stripe publishable key or account ID not found");
    r(3, a = await ui(E, { stripeAccount: B }));
  });
  const h = async () => {
    if (l || !a || !m)
      return;
    r(0, l = !0);
    const E = await a.confirmSetup({
      elements: m,
      redirect: "if_required"
    });
    E.error ? (r(0, l = !1), o(new Y(O.StripeError, E.error.message))) : i();
  };
  function y(E) {
    u = E, r(2, u);
  }
  return t.$$set = (E) => {
    "onClose" in E && r(1, n = E.onClose), "onContinue" in E && r(6, i = E.onContinue), "onError" in E && r(7, o = E.onError), "paymentInfoCollectionMetadata" in E && r(8, s = E.paymentInfoCollectionMetadata), "processing" in E && r(0, l = E.processing);
  }, t.$$.update = () => {
    t.$$.dirty & /*elements*/
    4 && u && u._elements.length > 0 && (m = u);
  }, [
    l,
    n,
    u,
    a,
    c,
    h,
    i,
    o,
    s,
    y
  ];
}
class Ni extends U {
  constructor(e) {
    super(), N(
      this,
      e,
      Ti,
      Qi,
      T,
      {
        onClose: 1,
        onContinue: 6,
        onError: 7,
        paymentInfoCollectionMetadata: 8,
        processing: 0
      },
      bi
    );
  }
}
function Ui(t) {
  return t.trim() === "" ? "You need to provide your email address to continue." : t.match(/^[^@]+@[^@]+\.[^@]+$/) ? null : "Email is not valid. Please provide a valid email address.";
}
function Ri(t) {
  x(t, "svelte-favd20", "form.svelte-favd20.svelte-favd20{display:flex;flex-direction:column;min-height:100%;flex-grow:1}.form-container.svelte-favd20.svelte-favd20{display:flex;flex-direction:column;width:100%;margin-top:32px;margin-bottom:16px}.form-label.svelte-favd20.svelte-favd20{margin-top:8px;margin-bottom:8px;display:block;font-weight:500;line-height:22px}.form-input.error.svelte-favd20 input.svelte-favd20{border-color:var(--rc-color-error)}.form-error.svelte-favd20.svelte-favd20{margin-top:4px;font-size:16px;line-height:20px;min-height:40px;color:var(--rc-color-error)}input.svelte-favd20.svelte-favd20{width:100%;box-sizing:border-box;padding:8px;border:2px solid var(--rc-color-grey-ui-dark);border-radius:12px;font-size:16px;height:48px;padding:6px 14px}input.svelte-favd20.svelte-favd20:focus{outline:none;border:2px solid var(--rc-color-focus)}");
}
function Si(t) {
  let e;
  return {
    c() {
      e = L("Billing email address");
    },
    m(r, n) {
      p(r, e, n);
    },
    d(r) {
      r && g(e);
    }
  };
}
function pt(t) {
  let e, r;
  return {
    c() {
      e = k("div"), r = L(
        /*error*/
        t[2]
      ), _(e, "class", "form-error svelte-favd20");
    },
    m(n, i) {
      p(n, e, i), M(e, r);
    },
    p(n, i) {
      i & /*error*/
      4 && ae(
        r,
        /*error*/
        n[2]
      );
    },
    d(n) {
      n && g(e);
    }
  };
}
function Oi(t) {
  let e, r, n, i, o, s, l, c, a, u = (
    /*error*/
    t[2] && pt(t)
  );
  return {
    c() {
      e = k("div"), r = k("div"), r.innerHTML = '<label for="email">Email</label>', n = Q(), i = k("div"), o = k("input"), l = Q(), u && u.c(), _(r, "class", "form-label svelte-favd20"), _(o, "name", "email"), _(o, "placeholder", "john@appleseed.com"), _(o, "autocapitalize", "off"), _(o, "class", "svelte-favd20"), _(i, "class", s = "form-input " + /*inputClass*/
      t[4] + " svelte-favd20"), _(e, "class", "form-container svelte-favd20");
    },
    m(m, h) {
      p(m, e, h), M(e, r), M(e, n), M(e, i), M(i, o), lt(
        o,
        /*email*/
        t[3]
      ), M(e, l), u && u.m(e, null), c || (a = we(
        o,
        "input",
        /*input_input_handler*/
        t[8]
      ), c = !0);
    },
    p(m, h) {
      h & /*email*/
      8 && o.value !== /*email*/
      m[3] && lt(
        o,
        /*email*/
        m[3]
      ), h & /*inputClass*/
      16 && s !== (s = "form-input " + /*inputClass*/
      m[4] + " svelte-favd20") && _(i, "class", s), /*error*/
      m[2] ? u ? u.p(m, h) : (u = pt(m), u.c(), u.m(e, null)) : u && (u.d(1), u = null);
    },
    d(m) {
      m && g(e), u && u.d(), c = !1, a();
    }
  };
}
function Li(t) {
  let e;
  return {
    c() {
      e = L("Continue");
    },
    m(r, n) {
      p(r, e, n);
    },
    i: v,
    o: v,
    d(r) {
      r && g(e);
    }
  };
}
function xi(t) {
  let e, r;
  return e = new xt({}), {
    c() {
      w(e.$$.fragment);
    },
    m(n, i) {
      b(e, n, i), r = !0;
    },
    i(n) {
      r || (f(e.$$.fragment, n), r = !0);
    },
    o(n) {
      d(e.$$.fragment, n), r = !1;
    },
    d(n) {
      I(e, n);
    }
  };
}
function Fi(t) {
  let e, r, n, i;
  const o = [xi, Li], s = [];
  function l(c, a) {
    return (
      /*processing*/
      c[1] ? 0 : 1
    );
  }
  return e = l(t), r = s[e] = o[e](t), {
    c() {
      r.c(), n = te();
    },
    m(c, a) {
      s[e].m(c, a), p(c, n, a), i = !0;
    },
    p(c, a) {
      let u = e;
      e = l(c), e !== u && (H(), d(s[u], 1, 1, () => {
        s[u] = null;
      }), K(), r = s[e], r || (r = s[e] = o[e](c), r.c()), f(r, 1), r.m(n.parentNode, n));
    },
    i(c) {
      i || (f(r), i = !0);
    },
    o(c) {
      d(r), i = !1;
    },
    d(c) {
      c && g(n), s[e].d(c);
    }
  };
}
function Gi(t) {
  let e;
  return {
    c() {
      e = L("Close");
    },
    m(r, n) {
      p(r, e, n);
    },
    d(r) {
      r && g(e);
    }
  };
}
function Yi(t) {
  let e, r, n, i;
  return e = new be({
    props: {
      disabled: (
        /*processing*/
        t[1]
      ),
      $$slots: { default: [Fi] },
      $$scope: { ctx: t }
    }
  }), n = new be({
    props: {
      intent: "secondary",
      disabled: (
        /*processing*/
        t[1]
      ),
      $$slots: { default: [Gi] },
      $$scope: { ctx: t }
    }
  }), n.$on("click", function() {
    ce(
      /*onClose*/
      t[0]
    ) && t[0].apply(this, arguments);
  }), {
    c() {
      w(e.$$.fragment), r = Q(), w(n.$$.fragment);
    },
    m(o, s) {
      b(e, o, s), p(o, r, s), b(n, o, s), i = !0;
    },
    p(o, s) {
      t = o;
      const l = {};
      s & /*processing*/
      2 && (l.disabled = /*processing*/
      t[1]), s & /*$$scope, processing*/
      514 && (l.$$scope = { dirty: s, ctx: t }), e.$set(l);
      const c = {};
      s & /*processing*/
      2 && (c.disabled = /*processing*/
      t[1]), s & /*$$scope*/
      512 && (c.$$scope = { dirty: s, ctx: t }), n.$set(c);
    },
    i(o) {
      i || (f(e.$$.fragment, o), f(n.$$.fragment, o), i = !0);
    },
    o(o) {
      d(e.$$.fragment, o), d(n.$$.fragment, o), i = !1;
    },
    d(o) {
      o && g(r), I(e, o), I(n, o);
    }
  };
}
function Hi(t) {
  let e, r;
  return e = new ye({
    props: {
      $$slots: { default: [Yi] },
      $$scope: { ctx: t }
    }
  }), {
    c() {
      w(e.$$.fragment);
    },
    m(n, i) {
      b(e, n, i), r = !0;
    },
    p(n, i) {
      const o = {};
      i & /*$$scope, processing, onClose*/
      515 && (o.$$scope = { dirty: i, ctx: n }), e.$set(o);
    },
    i(n) {
      r || (f(e.$$.fragment, n), r = !0);
    },
    o(n) {
      d(e.$$.fragment, n), r = !1;
    },
    d(n) {
      I(e, n);
    }
  };
}
function Ki(t) {
  let e, r, n, i, o, s, l, c, a;
  return r = new Xe({
    props: {
      $$slots: { default: [Si] },
      $$scope: { ctx: t }
    }
  }), i = new ue({
    props: {
      $$slots: { default: [Oi] },
      $$scope: { ctx: t }
    }
  }), s = new ze({
    props: {
      $$slots: { default: [Hi] },
      $$scope: { ctx: t }
    }
  }), {
    c() {
      e = k("form"), w(r.$$.fragment), n = Q(), w(i.$$.fragment), o = Q(), w(s.$$.fragment), _(e, "class", "svelte-favd20");
    },
    m(u, m) {
      p(u, e, m), b(r, e, null), M(e, n), b(i, e, null), M(e, o), b(s, e, null), l = !0, c || (a = we(e, "submit", Ct(
        /*handleContinue*/
        t[5]
      )), c = !0);
    },
    p(u, [m]) {
      const h = {};
      m & /*$$scope*/
      512 && (h.$$scope = { dirty: m, ctx: u }), r.$set(h);
      const y = {};
      m & /*$$scope, error, inputClass, email*/
      540 && (y.$$scope = { dirty: m, ctx: u }), i.$set(y);
      const E = {};
      m & /*$$scope, processing, onClose*/
      515 && (E.$$scope = { dirty: m, ctx: u }), s.$set(E);
    },
    i(u) {
      l || (f(r.$$.fragment, u), f(i.$$.fragment, u), f(s.$$.fragment, u), l = !0);
    },
    o(u) {
      d(r.$$.fragment, u), d(i.$$.fragment, u), d(s.$$.fragment, u), l = !1;
    },
    d(u) {
      u && g(e), I(r), I(i), I(s), c = !1, a();
    }
  };
}
function qi(t, e, r) {
  let n, i, o, { onContinue: s } = e, { onClose: l } = e, { processing: c } = e, { lastError: a } = e;
  const u = async () => {
    const h = Ui(n);
    h ? r(2, i = h) : s({ email: n });
  };
  _n(async () => {
    r(2, i = (a == null ? void 0 : a.message) ?? "");
  });
  function m() {
    n = this.value, r(3, n);
  }
  return t.$$set = (h) => {
    "onContinue" in h && r(6, s = h.onContinue), "onClose" in h && r(0, l = h.onClose), "processing" in h && r(1, c = h.processing), "lastError" in h && r(7, a = h.lastError);
  }, t.$$.update = () => {
    t.$$.dirty & /*error*/
    4 && r(4, o = i ? "error" : "");
  }, r(3, n = ""), r(2, i = ""), [
    l,
    c,
    i,
    n,
    o,
    u,
    s,
    a,
    m
  ];
}
class ji extends U {
  constructor(e) {
    super(), N(
      this,
      e,
      qi,
      Ki,
      T,
      {
        onContinue: 6,
        onClose: 0,
        processing: 1,
        lastError: 7
      },
      Ri
    );
  }
}
function Ji(t) {
  x(t, "svelte-17tslso", ".rcb-modal-backdrop.svelte-17tslso{position:fixed;top:0;left:0;right:0;min-width:100%;width:100vw;width:100dvw;min-height:100%;height:100vh;height:100dvh;background-color:rgba(40, 40, 40, 0.75);display:flex;flex-direction:column;justify-content:space-around;z-index:1000001}");
}
function Vi(t) {
  let e, r;
  const n = (
    /*#slots*/
    t[1].default
  ), i = q(
    n,
    t,
    /*$$scope*/
    t[0],
    null
  );
  return {
    c() {
      e = k("div"), i && i.c(), _(e, "class", "rcb-modal-backdrop svelte-17tslso");
    },
    m(o, s) {
      p(o, e, s), i && i.m(e, null), r = !0;
    },
    p(o, [s]) {
      i && i.p && (!r || s & /*$$scope*/
      1) && J(
        i,
        n,
        o,
        /*$$scope*/
        o[0],
        r ? j(
          n,
          /*$$scope*/
          o[0],
          s,
          null
        ) : V(
          /*$$scope*/
          o[0]
        ),
        null
      );
    },
    i(o) {
      r || (f(i, o), r = !0);
    },
    o(o) {
      d(i, o), r = !1;
    },
    d(o) {
      o && g(e), i && i.d(o);
    }
  };
}
function Wi(t, e, r) {
  let { $$slots: n = {}, $$scope: i } = e;
  return t.$$set = (o) => {
    "$$scope" in o && r(0, i = o.$$scope);
  }, [i, n];
}
class zi extends U {
  constructor(e) {
    super(), N(this, e, Wi, Vi, T, {}, Ji);
  }
}
function Xi(t) {
  x(t, "svelte-ioxu5d", ".rcb-modal-container.svelte-ioxu5d{width:100%}.rcb-modal-main.svelte-ioxu5d{box-sizing:border-box;border-radius:8px;background-color:var(--rc-color-white);color:var(--rc-color-grey-text-dark);min-height:460px;padding:40px;flex-direction:column;display:flex}.rcb-modal-dark.svelte-ioxu5d{background-color:var(--rc-color-grey-text-dark);color:var(--rc-color-white);min-height:0px}@media screen and (max-width: 960px){.rcb-modal-container.svelte-ioxu5d{width:calc(100% - 32px);min-width:300px;max-width:640px;margin:auto}.rcb-modal-main.svelte-ioxu5d,.rcb-modal-dark.svelte-ioxu5d{min-width:300px;max-width:640px;padding:32px}}");
}
function Zi(t) {
  let e, r, n, i;
  const o = (
    /*#slots*/
    t[2].default
  ), s = q(
    o,
    t,
    /*$$scope*/
    t[1],
    null
  );
  return {
    c() {
      e = k("div"), r = k("main"), s && s.c(), _(r, "class", n = Ae(`rcb-modal-main ${/*dark*/
      t[0] ? "rcb-modal-dark" : ""}`) + " svelte-ioxu5d"), _(e, "class", "rcb-modal-container svelte-ioxu5d");
    },
    m(l, c) {
      p(l, e, c), M(e, r), s && s.m(r, null), i = !0;
    },
    p(l, [c]) {
      s && s.p && (!i || c & /*$$scope*/
      2) && J(
        s,
        o,
        l,
        /*$$scope*/
        l[1],
        i ? j(
          o,
          /*$$scope*/
          l[1],
          c,
          null
        ) : V(
          /*$$scope*/
          l[1]
        ),
        null
      ), (!i || c & /*dark*/
      1 && n !== (n = Ae(`rcb-modal-main ${/*dark*/
      l[0] ? "rcb-modal-dark" : ""}`) + " svelte-ioxu5d")) && _(r, "class", n);
    },
    i(l) {
      i || (f(s, l), i = !0);
    },
    o(l) {
      d(s, l), i = !1;
    },
    d(l) {
      l && g(e), s && s.d(l);
    }
  };
}
function eo(t, e, r) {
  let { $$slots: n = {}, $$scope: i } = e, { dark: o = !1 } = e;
  return t.$$set = (s) => {
    "dark" in s && r(0, o = s.dark), "$$scope" in s && r(1, i = s.$$scope);
  }, [o, i, n];
}
class to extends U {
  constructor(e) {
    super(), N(this, e, eo, Zi, T, { dark: 0 }, Xi);
  }
}
function no(t) {
  let e;
  const r = (
    /*#slots*/
    t[1].default
  ), n = q(
    r,
    t,
    /*$$scope*/
    t[2],
    null
  );
  return {
    c() {
      n && n.c();
    },
    m(i, o) {
      n && n.m(i, o), e = !0;
    },
    p(i, o) {
      n && n.p && (!e || o & /*$$scope*/
      4) && J(
        n,
        r,
        i,
        /*$$scope*/
        i[2],
        e ? j(
          r,
          /*$$scope*/
          i[2],
          o,
          null
        ) : V(
          /*$$scope*/
          i[2]
        ),
        null
      );
    },
    i(i) {
      e || (f(n, i), e = !0);
    },
    o(i) {
      d(n, i), e = !1;
    },
    d(i) {
      n && n.d(i);
    }
  };
}
function ro(t) {
  let e, r;
  return e = new zi({
    props: {
      $$slots: { default: [io] },
      $$scope: { ctx: t }
    }
  }), {
    c() {
      w(e.$$.fragment);
    },
    m(n, i) {
      b(e, n, i), r = !0;
    },
    p(n, i) {
      const o = {};
      i & /*$$scope*/
      4 && (o.$$scope = { dirty: i, ctx: n }), e.$set(o);
    },
    i(n) {
      r || (f(e.$$.fragment, n), r = !0);
    },
    o(n) {
      d(e.$$.fragment, n), r = !1;
    },
    d(n) {
      I(e, n);
    }
  };
}
function io(t) {
  let e;
  const r = (
    /*#slots*/
    t[1].default
  ), n = q(
    r,
    t,
    /*$$scope*/
    t[2],
    null
  );
  return {
    c() {
      n && n.c();
    },
    m(i, o) {
      n && n.m(i, o), e = !0;
    },
    p(i, o) {
      n && n.p && (!e || o & /*$$scope*/
      4) && J(
        n,
        r,
        i,
        /*$$scope*/
        i[2],
        e ? j(
          r,
          /*$$scope*/
          i[2],
          o,
          null
        ) : V(
          /*$$scope*/
          i[2]
        ),
        null
      );
    },
    i(i) {
      e || (f(n, i), e = !0);
    },
    o(i) {
      d(n, i), e = !1;
    },
    d(i) {
      n && n.d(i);
    }
  };
}
function oo(t) {
  let e, r, n, i;
  const o = [ro, no], s = [];
  function l(c, a) {
    return (
      /*condition*/
      c[0] ? 0 : 1
    );
  }
  return e = l(t), r = s[e] = o[e](t), {
    c() {
      r.c(), n = te();
    },
    m(c, a) {
      s[e].m(c, a), p(c, n, a), i = !0;
    },
    p(c, [a]) {
      let u = e;
      e = l(c), e === u ? s[e].p(c, a) : (H(), d(s[u], 1, 1, () => {
        s[u] = null;
      }), K(), r = s[e], r ? r.p(c, a) : (r = s[e] = o[e](c), r.c()), f(r, 1), r.m(n.parentNode, n));
    },
    i(c) {
      i || (f(r), i = !0);
    },
    o(c) {
      d(r), i = !1;
    },
    d(c) {
      c && g(n), s[e].d(c);
    }
  };
}
function so(t, e, r) {
  let { $$slots: n = {}, $$scope: i } = e, { condition: o = !1 } = e;
  return t.$$set = (s) => {
    "condition" in s && r(0, o = s.condition), "$$scope" in s && r(2, i = s.$$scope);
  }, [o, n, i];
}
class lo extends U {
  constructor(e) {
    super(), N(this, e, so, oo, T, { condition: 0 });
  }
}
const co = (t) => ({}), _t = (t) => ({});
function ao(t) {
  let e, r;
  const n = (
    /*#slots*/
    t[1].header
  ), i = q(
    n,
    t,
    /*$$scope*/
    t[2],
    _t
  ), o = (
    /*#slots*/
    t[1].default
  ), s = q(
    o,
    t,
    /*$$scope*/
    t[2],
    null
  );
  return {
    c() {
      i && i.c(), e = Q(), s && s.c();
    },
    m(l, c) {
      i && i.m(l, c), p(l, e, c), s && s.m(l, c), r = !0;
    },
    p(l, c) {
      i && i.p && (!r || c & /*$$scope*/
      4) && J(
        i,
        n,
        l,
        /*$$scope*/
        l[2],
        r ? j(
          n,
          /*$$scope*/
          l[2],
          c,
          co
        ) : V(
          /*$$scope*/
          l[2]
        ),
        _t
      ), s && s.p && (!r || c & /*$$scope*/
      4) && J(
        s,
        o,
        l,
        /*$$scope*/
        l[2],
        r ? j(
          o,
          /*$$scope*/
          l[2],
          c,
          null
        ) : V(
          /*$$scope*/
          l[2]
        ),
        null
      );
    },
    i(l) {
      r || (f(i, l), f(s, l), r = !0);
    },
    o(l) {
      d(i, l), d(s, l), r = !1;
    },
    d(l) {
      l && g(e), i && i.d(l), s && s.d(l);
    }
  };
}
function uo(t) {
  let e, r;
  return e = new to({
    props: {
      dark: (
        /*dark*/
        t[0]
      ),
      $$slots: { default: [ao] },
      $$scope: { ctx: t }
    }
  }), {
    c() {
      w(e.$$.fragment);
    },
    m(n, i) {
      b(e, n, i), r = !0;
    },
    p(n, [i]) {
      const o = {};
      i & /*dark*/
      1 && (o.dark = /*dark*/
      n[0]), i & /*$$scope*/
      4 && (o.$$scope = { dirty: i, ctx: n }), e.$set(o);
    },
    i(n) {
      r || (f(e.$$.fragment, n), r = !0);
    },
    o(n) {
      d(e.$$.fragment, n), r = !1;
    },
    d(n) {
      I(e, n);
    }
  };
}
function fo(t, e, r) {
  let { $$slots: n = {}, $$scope: i } = e, { dark: o = !1 } = e;
  return t.$$set = (s) => {
    "dark" in s && r(0, o = s.dark), "$$scope" in s && r(2, i = s.$$scope);
  }, [o, n, i];
}
class Ft extends U {
  constructor(e) {
    super(), N(this, e, fo, uo, T, { dark: 0 });
  }
}
const mo = "0.4.0", go = "https://api.revenuecat.com";
var Re;
(function(t) {
  t[t.CONTINUE = 100] = "CONTINUE", t[t.SWITCHING_PROTOCOLS = 101] = "SWITCHING_PROTOCOLS", t[t.PROCESSING = 102] = "PROCESSING", t[t.EARLY_HINTS = 103] = "EARLY_HINTS", t[t.OK = 200] = "OK", t[t.CREATED = 201] = "CREATED", t[t.ACCEPTED = 202] = "ACCEPTED", t[t.NON_AUTHORITATIVE_INFORMATION = 203] = "NON_AUTHORITATIVE_INFORMATION", t[t.NO_CONTENT = 204] = "NO_CONTENT", t[t.RESET_CONTENT = 205] = "RESET_CONTENT", t[t.PARTIAL_CONTENT = 206] = "PARTIAL_CONTENT", t[t.MULTI_STATUS = 207] = "MULTI_STATUS", t[t.MULTIPLE_CHOICES = 300] = "MULTIPLE_CHOICES", t[t.MOVED_PERMANENTLY = 301] = "MOVED_PERMANENTLY", t[t.MOVED_TEMPORARILY = 302] = "MOVED_TEMPORARILY", t[t.SEE_OTHER = 303] = "SEE_OTHER", t[t.NOT_MODIFIED = 304] = "NOT_MODIFIED", t[t.USE_PROXY = 305] = "USE_PROXY", t[t.TEMPORARY_REDIRECT = 307] = "TEMPORARY_REDIRECT", t[t.PERMANENT_REDIRECT = 308] = "PERMANENT_REDIRECT", t[t.BAD_REQUEST = 400] = "BAD_REQUEST", t[t.UNAUTHORIZED = 401] = "UNAUTHORIZED", t[t.PAYMENT_REQUIRED = 402] = "PAYMENT_REQUIRED", t[t.FORBIDDEN = 403] = "FORBIDDEN", t[t.NOT_FOUND = 404] = "NOT_FOUND", t[t.METHOD_NOT_ALLOWED = 405] = "METHOD_NOT_ALLOWED", t[t.NOT_ACCEPTABLE = 406] = "NOT_ACCEPTABLE", t[t.PROXY_AUTHENTICATION_REQUIRED = 407] = "PROXY_AUTHENTICATION_REQUIRED", t[t.REQUEST_TIMEOUT = 408] = "REQUEST_TIMEOUT", t[t.CONFLICT = 409] = "CONFLICT", t[t.GONE = 410] = "GONE", t[t.LENGTH_REQUIRED = 411] = "LENGTH_REQUIRED", t[t.PRECONDITION_FAILED = 412] = "PRECONDITION_FAILED", t[t.REQUEST_TOO_LONG = 413] = "REQUEST_TOO_LONG", t[t.REQUEST_URI_TOO_LONG = 414] = "REQUEST_URI_TOO_LONG", t[t.UNSUPPORTED_MEDIA_TYPE = 415] = "UNSUPPORTED_MEDIA_TYPE", t[t.REQUESTED_RANGE_NOT_SATISFIABLE = 416] = "REQUESTED_RANGE_NOT_SATISFIABLE", t[t.EXPECTATION_FAILED = 417] = "EXPECTATION_FAILED", t[t.IM_A_TEAPOT = 418] = "IM_A_TEAPOT", t[t.INSUFFICIENT_SPACE_ON_RESOURCE = 419] = "INSUFFICIENT_SPACE_ON_RESOURCE", t[t.METHOD_FAILURE = 420] = "METHOD_FAILURE", t[t.MISDIRECTED_REQUEST = 421] = "MISDIRECTED_REQUEST", t[t.UNPROCESSABLE_ENTITY = 422] = "UNPROCESSABLE_ENTITY", t[t.LOCKED = 423] = "LOCKED", t[t.FAILED_DEPENDENCY = 424] = "FAILED_DEPENDENCY", t[t.UPGRADE_REQUIRED = 426] = "UPGRADE_REQUIRED", t[t.PRECONDITION_REQUIRED = 428] = "PRECONDITION_REQUIRED", t[t.TOO_MANY_REQUESTS = 429] = "TOO_MANY_REQUESTS", t[t.REQUEST_HEADER_FIELDS_TOO_LARGE = 431] = "REQUEST_HEADER_FIELDS_TOO_LARGE", t[t.UNAVAILABLE_FOR_LEGAL_REASONS = 451] = "UNAVAILABLE_FOR_LEGAL_REASONS", t[t.INTERNAL_SERVER_ERROR = 500] = "INTERNAL_SERVER_ERROR", t[t.NOT_IMPLEMENTED = 501] = "NOT_IMPLEMENTED", t[t.BAD_GATEWAY = 502] = "BAD_GATEWAY", t[t.SERVICE_UNAVAILABLE = 503] = "SERVICE_UNAVAILABLE", t[t.GATEWAY_TIMEOUT = 504] = "GATEWAY_TIMEOUT", t[t.HTTP_VERSION_NOT_SUPPORTED = 505] = "HTTP_VERSION_NOT_SUPPORTED", t[t.INSUFFICIENT_STORAGE = 507] = "INSUFFICIENT_STORAGE", t[t.NETWORK_AUTHENTICATION_REQUIRED = 511] = "NETWORK_AUTHENTICATION_REQUIRED";
})(Re || (Re = {}));
function qe(t) {
  return t ? t.startsWith("rcb_sb_") : !1;
}
async function oe(t, e) {
  const { apiKey: r, body: n, headers: i, httpConfig: o } = e, l = `${(o == null ? void 0 : o.proxyURL) ?? go}${t.urlPath()}`;
  try {
    const c = await fetch(l, {
      method: t.method,
      headers: ho(r, i, o == null ? void 0 : o.additionalHeaders),
      body: _o(n)
    });
    return await po(c, t), await c.json();
  } catch (c) {
    throw c instanceof TypeError ? new z(
      Z.NetworkError,
      he.getPublicMessage(Z.NetworkError),
      c.message
    ) : c;
  }
}
async function po(t, e) {
  const r = t.status;
  if (r >= Re.INTERNAL_SERVER_ERROR)
    Ge(e, r, await t.text());
  else if (r >= Re.BAD_REQUEST) {
    const n = await t.json(), i = n ? JSON.stringify(n) : null, o = n == null ? void 0 : n.code, s = n == null ? void 0 : n.message;
    if (o != null) {
      const l = he.convertCodeToBackendErrorCode(o);
      if (l == null)
        Ge(e, r, i);
      else
        throw z.getForBackendError(
          l,
          s
        );
    } else
      Ge(e, r, i);
  }
}
function Ge(t, e, r) {
  throw new z(
    Z.UnknownBackendError,
    `Unknown backend error. Request: ${t.name}. Status code: ${e}. Body: ${r}.`
  );
}
function _o(t) {
  return t == null ? null : JSON.stringify(t);
}
function ho(t, e, r) {
  let n = {
    Authorization: `Bearer ${t}`,
    "Content-Type": "application/json",
    Accept: "application/json",
    "X-Platform": "web",
    "X-Version": mo,
    "X-Is-Sandbox": `${qe(t)}`
  };
  return e && (n = { ...n, ...e }), r && (n = { ...r, ...n }), n;
}
const Gt = "/v1/subscribers", Oe = "/rcbilling/v1";
class Ao {
  constructor(e) {
    P(this, "appUserId");
    P(this, "method", "GET");
    P(this, "name", "getOfferings");
    this.appUserId = e;
  }
  urlPath() {
    const e = encodeURIComponent(this.appUserId);
    return `${Gt}/${e}/offerings`;
  }
}
class Eo {
  constructor() {
    P(this, "method", "POST");
    P(this, "name", "subscribe");
  }
  urlPath() {
    return `${Oe}/subscribe`;
  }
}
class bo {
  constructor(e, r) {
    P(this, "method", "GET");
    P(this, "name", "getProducts");
    P(this, "appUserId");
    P(this, "productIds");
    this.appUserId = e, this.productIds = r;
  }
  urlPath() {
    const e = encodeURIComponent(this.appUserId), r = this.productIds.map(encodeURIComponent).join("&id=");
    return `${Oe}/subscribers/${e}/products?id=${r}`;
  }
}
class Io {
  constructor(e) {
    P(this, "method", "GET");
    P(this, "name", "getCustomerInfo");
    P(this, "appUserId");
    this.appUserId = e;
  }
  urlPath() {
    const e = encodeURIComponent(this.appUserId);
    return `${Gt}/${e}`;
  }
}
class wo {
  constructor() {
    P(this, "method", "GET");
    P(this, "name", "getBrandingInfo");
  }
  urlPath() {
    return `${Oe}/branding`;
  }
}
class ko {
  constructor(e) {
    P(this, "method", "GET");
    P(this, "name", "getCheckoutStatus");
    P(this, "operationSessionId");
    this.operationSessionId = e;
  }
  urlPath() {
    return `${Oe}/checkout/${this.operationSessionId}`;
  }
}
const je = {};
class yo {
  constructor(e, r = je) {
    P(this, "API_KEY");
    P(this, "httpConfig");
    this.API_KEY = e, this.httpConfig = r;
  }
  async getOfferings(e) {
    return await oe(
      new Ao(e),
      {
        apiKey: this.API_KEY,
        httpConfig: this.httpConfig
      }
    );
  }
  async getCustomerInfo(e) {
    return await oe(
      new Io(e),
      {
        apiKey: this.API_KEY,
        httpConfig: this.httpConfig
      }
    );
  }
  async getProducts(e, r) {
    return await oe(
      new bo(e, r),
      {
        apiKey: this.API_KEY,
        httpConfig: this.httpConfig
      }
    );
  }
  async getBrandingInfo() {
    return await oe(
      new wo(),
      {
        apiKey: this.API_KEY,
        httpConfig: this.httpConfig
      }
    );
  }
  async postSubscribe(e, r, n, i, o) {
    const s = {
      app_user_id: e,
      product_id: r,
      email: n,
      presented_offering_identifier: i
    };
    return o && o !== "base_option" && (s.offer_id = o), await oe(
      new Eo(),
      {
        apiKey: this.API_KEY,
        body: s,
        httpConfig: this.httpConfig
      }
    );
  }
  async getCheckoutStatus(e) {
    return await oe(
      new ko(e),
      {
        apiKey: this.API_KEY,
        httpConfig: this.httpConfig
      }
    );
  }
}
const vo = "data:image/svg+xml,%3csvg%20width='24'%20height='24'%20viewBox='0%200%2024%2024'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cg%20opacity='0.5'%20clip-path='url(%23clip0_344_3390)'%3e%3cpath%20d='M7%2018C5.9%2018%205.01%2018.9%205.01%2020C5.01%2021.1%205.9%2022%207%2022C8.1%2022%209%2021.1%209%2020C9%2018.9%208.1%2018%207%2018ZM1%202V4H3L6.6%2011.59L5.25%2014.04C5.09%2014.32%205%2014.65%205%2015C5%2016.1%205.9%2017%207%2017H19V15H7.42C7.28%2015%207.17%2014.89%207.17%2014.75L7.2%2014.63L8.1%2013H15.55C16.3%2013%2016.96%2012.59%2017.3%2011.97L20.88%205.48C20.96%205.34%2021%205.17%2021%205C21%204.45%2020.55%204%2020%204H5.21L4.27%202H1ZM17%2018C15.9%2018%2015.01%2018.9%2015.01%2020C15.01%2021.1%2015.9%2022%2017%2022C18.1%2022%2019%2021.1%2019%2020C19%2018.9%2018.1%2018%2017%2018Z'%20fill='white'/%3e%3c/g%3e%3cdefs%3e%3cclipPath%20id='clip0_344_3390'%3e%3crect%20width='24'%20height='24'%20fill='white'/%3e%3c/clipPath%3e%3c/defs%3e%3c/svg%3e";
function $o(t) {
  let e, r;
  return {
    c() {
      e = k("img"), ee(e.src, r = vo) || _(e, "src", r), _(e, "alt", "icon"), _(e, "class", "rcb-ui-asset-icon");
    },
    m(n, i) {
      p(n, e, i);
    },
    p: v,
    i: v,
    o: v,
    d(n) {
      n && g(e);
    }
  };
}
class Bo extends U {
  constructor(e) {
    super(), N(this, e, null, $o, T, {});
  }
}
function Do(t) {
  x(t, "svelte-1rhrjxe", "div.svelte-1rhrjxe{background-color:var(--rc-color-warning);color:var(--rc-color-grey-text-dark);font-size:10px;font-weight:bold;text-transform:uppercase;padding:4px 10px;line-height:10px;border-radius:9px;margin:0px;margin-left:16px}");
}
function Co(t) {
  let e;
  return {
    c() {
      e = k("div"), e.textContent = "Sandbox", _(e, "class", "svelte-1rhrjxe");
    },
    m(r, n) {
      p(r, e, n);
    },
    p: v,
    i: v,
    o: v,
    d(r) {
      r && g(e);
    }
  };
}
class Po extends U {
  constructor(e) {
    super(), N(this, e, null, Co, T, {}, Do);
  }
}
function Mo(t) {
  x(t, "svelte-1qect5g", `.rcb-ui-container.svelte-1qect5g{color-scheme:none;font-size:16px;line-height:1.5em;font-weight:400;font-family:-apple-system, "system-ui", "Segoe UI", Roboto, Oxygen, Ubuntu,
        Cantarell, "Open Sans", "Helvetica Neue", sans-serif}.rcb-ui-layout.svelte-1qect5g{width:100vw;width:100 dvw;margin-right:auto;display:flex;justify-content:center;align-items:flex-start;position:relative;padding:0px 80px;box-sizing:border-box}.rcb-ui-aside.svelte-1qect5g{margin-right:16px;flex:320px 1 0;max-width:480px}.rcb-ui-main.svelte-1qect5g{flex:480px 1 0;max-width:640px}@media screen and (max-width: 960px){.rcb-ui-layout.svelte-1qect5g{flex-direction:column;align-items:center;justify-content:center;height:100%;min-width:100%}.rcb-ui-aside.svelte-1qect5g{margin-right:0;margin-bottom:16px;min-width:100%;display:flex;flex-direction:column;align-items:center;flex:none;max-width:none}.rcb-ui-main.svelte-1qect5g{flex:none;max-width:none;min-width:100%}}@media screen and (max-width: 960px) and (max-height: 960px){.rcb-ui-layout.svelte-1qect5g{overflow-y:scroll;justify-content:flex-start;padding:16px 0px}}`);
}
function ht(t) {
  let e, r, n;
  return r = new Ft({
    props: {
      dark: !0,
      $$slots: {
        header: [Ro],
        default: [Qo]
      },
      $$scope: { ctx: t }
    }
  }), {
    c() {
      e = k("div"), w(r.$$.fragment), _(e, "class", "rcb-ui-aside svelte-1qect5g");
    },
    m(i, o) {
      p(i, e, o), b(r, e, null), n = !0;
    },
    p(i, o) {
      const s = {};
      o & /*$$scope, purchases, brandingInfo, productDetails*/
      67108878 && (s.$$scope = { dirty: o, ctx: i }), r.$set(s);
    },
    i(i) {
      n || (f(r.$$.fragment, i), n = !0);
    },
    o(i) {
      d(r.$$.fragment, i), n = !1;
    },
    d(i) {
      i && g(e), I(r);
    }
  };
}
function At(t) {
  let e, r;
  return e = new Qt({
    props: {
      productDetails: (
        /*productDetails*/
        t[2]
      ),
      purchaseOption: (
        /*purchaseOptionToUse*/
        t[8]
      )
    }
  }), {
    c() {
      w(e.$$.fragment);
    },
    m(n, i) {
      b(e, n, i), r = !0;
    },
    p(n, i) {
      const o = {};
      i & /*productDetails*/
      4 && (o.productDetails = /*productDetails*/
      n[2]), e.$set(o);
    },
    i(n) {
      r || (f(e.$$.fragment, n), r = !0);
    },
    o(n) {
      d(e.$$.fragment, n), r = !1;
    },
    d(n) {
      I(e, n);
    }
  };
}
function Qo(t) {
  let e, r, n = (
    /*productDetails*/
    t[2] && /*purchaseOptionToUse*/
    t[8] && At(t)
  );
  return {
    c() {
      n && n.c(), e = te();
    },
    m(i, o) {
      n && n.m(i, o), p(i, e, o), r = !0;
    },
    p(i, o) {
      /*productDetails*/
      i[2] && /*purchaseOptionToUse*/
      i[8] ? n ? (n.p(i, o), o & /*productDetails*/
      4 && f(n, 1)) : (n = At(i), n.c(), f(n, 1), n.m(e.parentNode, e)) : n && (H(), d(n, 1, 1, () => {
        n = null;
      }), K());
    },
    i(i) {
      r || (f(n), r = !0);
    },
    o(i) {
      d(n), r = !1;
    },
    d(i) {
      i && g(e), n && n.d(i);
    }
  };
}
function To(t) {
  let e, r;
  return e = new Bo({}), {
    c() {
      w(e.$$.fragment);
    },
    m(n, i) {
      b(e, n, i), r = !0;
    },
    i(n) {
      r || (f(e.$$.fragment, n), r = !0);
    },
    o(n) {
      d(e.$$.fragment, n), r = !1;
    },
    d(n) {
      I(e, n);
    }
  };
}
function No(t) {
  let e, r;
  return e = new Po({}), {
    c() {
      w(e.$$.fragment);
    },
    m(n, i) {
      b(e, n, i), r = !0;
    },
    i(n) {
      r || (f(e.$$.fragment, n), r = !0);
    },
    o(n) {
      d(e.$$.fragment, n), r = !1;
    },
    d(n) {
      I(e, n);
    }
  };
}
function Uo(t) {
  let e, r, n, i, o, s, l;
  e = new Ut({
    props: { brandingInfo: (
      /*brandingInfo*/
      t[3]
    ) }
  });
  const c = [No, To], a = [];
  function u(m, h) {
    return h & /*purchases*/
    2 && (n = null), n == null && (n = !!/*purchases*/
    m[1].isSandbox()), n ? 0 : 1;
  }
  return i = u(t, -1), o = a[i] = c[i](t), {
    c() {
      w(e.$$.fragment), r = Q(), o.c(), s = te();
    },
    m(m, h) {
      b(e, m, h), p(m, r, h), a[i].m(m, h), p(m, s, h), l = !0;
    },
    p(m, h) {
      const y = {};
      h & /*brandingInfo*/
      8 && (y.brandingInfo = /*brandingInfo*/
      m[3]), e.$set(y);
      let E = i;
      i = u(m, h), i !== E && (H(), d(a[E], 1, 1, () => {
        a[E] = null;
      }), K(), o = a[i], o || (o = a[i] = c[i](m), o.c()), f(o, 1), o.m(s.parentNode, s));
    },
    i(m) {
      l || (f(e.$$.fragment, m), f(o), l = !0);
    },
    o(m) {
      d(e.$$.fragment, m), d(o), l = !1;
    },
    d(m) {
      m && (g(r), g(s)), I(e, m), a[i].d(m);
    }
  };
}
function Ro(t) {
  let e, r;
  return e = new Xe({
    props: {
      slot: "header",
      $$slots: { default: [Uo] },
      $$scope: { ctx: t }
    }
  }), {
    c() {
      w(e.$$.fragment);
    },
    m(n, i) {
      b(e, n, i), r = !0;
    },
    p(n, i) {
      const o = {};
      i & /*$$scope, purchases, brandingInfo*/
      67108874 && (o.$$scope = { dirty: i, ctx: n }), e.$set(o);
    },
    i(n) {
      r || (f(e.$$.fragment, n), r = !0);
    },
    o(n) {
      d(e.$$.fragment, n), r = !1;
    },
    d(n) {
      I(e, n);
    }
  };
}
function Et(t) {
  let e, r;
  return e = new Qt({
    props: {
      productDetails: (
        /*productDetails*/
        t[2]
      ),
      purchaseOption: (
        /*purchaseOptionToUse*/
        t[8]
      )
    }
  }), {
    c() {
      w(e.$$.fragment);
    },
    m(n, i) {
      b(e, n, i), r = !0;
    },
    p(n, i) {
      const o = {};
      i & /*productDetails*/
      4 && (o.productDetails = /*productDetails*/
      n[2]), e.$set(o);
    },
    i(n) {
      r || (f(e.$$.fragment, n), r = !0);
    },
    o(n) {
      d(e.$$.fragment, n), r = !1;
    },
    d(n) {
      I(e, n);
    }
  };
}
function bt(t) {
  let e, r;
  return e = new We({}), {
    c() {
      w(e.$$.fragment);
    },
    m(n, i) {
      b(e, n, i), r = !0;
    },
    i(n) {
      r || (f(e.$$.fragment, n), r = !0);
    },
    o(n) {
      d(e.$$.fragment, n), r = !1;
    },
    d(n) {
      I(e, n);
    }
  };
}
function It(t) {
  let e, r;
  return e = new ji({
    props: {
      onContinue: (
        /*handleContinue*/
        t[11]
      ),
      onClose: (
        /*handleClose*/
        t[10]
      ),
      processing: (
        /*state*/
        t[6] === "processing-auth-info"
      ),
      lastError: (
        /*lastError*/
        t[5]
      )
    }
  }), {
    c() {
      w(e.$$.fragment);
    },
    m(n, i) {
      b(e, n, i), r = !0;
    },
    p(n, i) {
      const o = {};
      i & /*state*/
      64 && (o.processing = /*state*/
      n[6] === "processing-auth-info"), i & /*lastError*/
      32 && (o.lastError = /*lastError*/
      n[5]), e.$set(o);
    },
    i(n) {
      r || (f(e.$$.fragment, n), r = !0);
    },
    o(n) {
      d(e.$$.fragment, n), r = !1;
    },
    d(n) {
      I(e, n);
    }
  };
}
function wt(t) {
  let e, r;
  return e = new Ni({
    props: {
      paymentInfoCollectionMetadata: (
        /*paymentInfoCollectionMetadata*/
        t[4]
      ),
      onContinue: (
        /*handleContinue*/
        t[11]
      ),
      onClose: (
        /*handleClose*/
        t[10]
      ),
      onError: (
        /*handleError*/
        t[12]
      ),
      processing: (
        /*state*/
        t[6] === "polling-purchase-status"
      )
    }
  }), {
    c() {
      w(e.$$.fragment);
    },
    m(n, i) {
      b(e, n, i), r = !0;
    },
    p(n, i) {
      const o = {};
      i & /*paymentInfoCollectionMetadata*/
      16 && (o.paymentInfoCollectionMetadata = /*paymentInfoCollectionMetadata*/
      n[4]), i & /*state*/
      64 && (o.processing = /*state*/
      n[6] === "polling-purchase-status"), e.$set(o);
    },
    i(n) {
      r || (f(e.$$.fragment, n), r = !0);
    },
    o(n) {
      d(e.$$.fragment, n), r = !1;
    },
    d(n) {
      I(e, n);
    }
  };
}
function kt(t) {
  let e, r;
  return e = new We({}), {
    c() {
      w(e.$$.fragment);
    },
    m(n, i) {
      b(e, n, i), r = !0;
    },
    i(n) {
      r || (f(e.$$.fragment, n), r = !0);
    },
    o(n) {
      d(e.$$.fragment, n), r = !1;
    },
    d(n) {
      I(e, n);
    }
  };
}
function yt(t) {
  var n;
  let e, r;
  return e = new Or({
    props: {
      brandingInfo: (
        /*brandingInfo*/
        t[3]
      ),
      lastError: (
        /*lastError*/
        t[5] ?? new Y(O.UnknownError, "Unknown error without state set.")
      ),
      supportEmail: (
        /*brandingInfo*/
        (n = t[3]) == null ? void 0 : n.seller_company_support_email
      ),
      onContinue: (
        /*closeWithError*/
        t[13]
      )
    }
  }), {
    c() {
      w(e.$$.fragment);
    },
    m(i, o) {
      b(e, i, o), r = !0;
    },
    p(i, o) {
      var l;
      const s = {};
      o & /*brandingInfo*/
      8 && (s.brandingInfo = /*brandingInfo*/
      i[3]), o & /*lastError*/
      32 && (s.lastError = /*lastError*/
      i[5] ?? new Y(O.UnknownError, "Unknown error without state set.")), o & /*brandingInfo*/
      8 && (s.supportEmail = /*brandingInfo*/
      (l = i[3]) == null ? void 0 : l.seller_company_support_email), e.$set(s);
    },
    i(i) {
      r || (f(e.$$.fragment, i), r = !0);
    },
    o(i) {
      d(e.$$.fragment, i), r = !1;
    },
    d(i) {
      I(e, i);
    }
  };
}
function vt(t) {
  let e, r;
  return e = new jr({
    props: {
      brandingInfo: (
        /*brandingInfo*/
        t[3]
      ),
      onContinue: (
        /*handleContinue*/
        t[11]
      )
    }
  }), {
    c() {
      w(e.$$.fragment);
    },
    m(n, i) {
      b(e, n, i), r = !0;
    },
    p(n, i) {
      const o = {};
      i & /*brandingInfo*/
      8 && (o.brandingInfo = /*brandingInfo*/
      n[3]), e.$set(o);
    },
    i(n) {
      r || (f(e.$$.fragment, n), r = !0);
    },
    o(n) {
      d(e.$$.fragment, n), r = !1;
    },
    d(n) {
      I(e, n);
    }
  };
}
function So(t) {
  let e, r, n, i, o, s, l, c, a = (
    /*state*/
    t[6] === "present-offer" && /*productDetails*/
    t[2] && /*purchaseOptionToUse*/
    t[8] && Et(t)
  ), u = (
    /*state*/
    t[6] === "present-offer" && !/*productDetails*/
    t[2] && bt()
  ), m = (
    /*state*/
    (t[6] === "needs-auth-info" || /*state*/
    t[6] === "processing-auth-info") && It(t)
  ), h = (
    /*paymentInfoCollectionMetadata*/
    t[4] && /*state*/
    (t[6] === "needs-payment-info" || /*state*/
    t[6] === "polling-purchase-status") && wt(t)
  ), y = (
    /*state*/
    t[6] === "loading" && kt()
  ), E = (
    /*state*/
    t[6] === "error" && yt(t)
  ), B = (
    /*state*/
    t[6] === "success" && vt(t)
  );
  return {
    c() {
      a && a.c(), e = Q(), u && u.c(), r = Q(), m && m.c(), n = Q(), h && h.c(), i = Q(), y && y.c(), o = Q(), E && E.c(), s = Q(), B && B.c(), l = te();
    },
    m(A, $) {
      a && a.m(A, $), p(A, e, $), u && u.m(A, $), p(A, r, $), m && m.m(A, $), p(A, n, $), h && h.m(A, $), p(A, i, $), y && y.m(A, $), p(A, o, $), E && E.m(A, $), p(A, s, $), B && B.m(A, $), p(A, l, $), c = !0;
    },
    p(A, $) {
      /*state*/
      A[6] === "present-offer" && /*productDetails*/
      A[2] && /*purchaseOptionToUse*/
      A[8] ? a ? (a.p(A, $), $ & /*state, productDetails*/
      68 && f(a, 1)) : (a = Et(A), a.c(), f(a, 1), a.m(e.parentNode, e)) : a && (H(), d(a, 1, 1, () => {
        a = null;
      }), K()), /*state*/
      A[6] === "present-offer" && !/*productDetails*/
      A[2] ? u ? $ & /*state, productDetails*/
      68 && f(u, 1) : (u = bt(), u.c(), f(u, 1), u.m(r.parentNode, r)) : u && (H(), d(u, 1, 1, () => {
        u = null;
      }), K()), /*state*/
      A[6] === "needs-auth-info" || /*state*/
      A[6] === "processing-auth-info" ? m ? (m.p(A, $), $ & /*state*/
      64 && f(m, 1)) : (m = It(A), m.c(), f(m, 1), m.m(n.parentNode, n)) : m && (H(), d(m, 1, 1, () => {
        m = null;
      }), K()), /*paymentInfoCollectionMetadata*/
      A[4] && /*state*/
      (A[6] === "needs-payment-info" || /*state*/
      A[6] === "polling-purchase-status") ? h ? (h.p(A, $), $ & /*paymentInfoCollectionMetadata, state*/
      80 && f(h, 1)) : (h = wt(A), h.c(), f(h, 1), h.m(i.parentNode, i)) : h && (H(), d(h, 1, 1, () => {
        h = null;
      }), K()), /*state*/
      A[6] === "loading" ? y ? $ & /*state*/
      64 && f(y, 1) : (y = kt(), y.c(), f(y, 1), y.m(o.parentNode, o)) : y && (H(), d(y, 1, 1, () => {
        y = null;
      }), K()), /*state*/
      A[6] === "error" ? E ? (E.p(A, $), $ & /*state*/
      64 && f(E, 1)) : (E = yt(A), E.c(), f(E, 1), E.m(s.parentNode, s)) : E && (H(), d(E, 1, 1, () => {
        E = null;
      }), K()), /*state*/
      A[6] === "success" ? B ? (B.p(A, $), $ & /*state*/
      64 && f(B, 1)) : (B = vt(A), B.c(), f(B, 1), B.m(l.parentNode, l)) : B && (H(), d(B, 1, 1, () => {
        B = null;
      }), K());
    },
    i(A) {
      c || (f(a), f(u), f(m), f(h), f(y), f(E), f(B), c = !0);
    },
    o(A) {
      d(a), d(u), d(m), d(h), d(y), d(E), d(B), c = !1;
    },
    d(A) {
      A && (g(e), g(r), g(n), g(i), g(o), g(s), g(l)), a && a.d(A), u && u.d(A), m && m.d(A), h && h.d(A), y && y.d(A), E && E.d(A), B && B.d(A);
    }
  };
}
function Oo(t) {
  let e, r = (
    /*statesWhereOfferDetailsAreShown*/
    t[9].includes(
      /*state*/
      t[6]
    )
  ), n, i, o, s, l = r && ht(t);
  return o = new Ft({
    props: {
      $$slots: { default: [So] },
      $$scope: { ctx: t }
    }
  }), {
    c() {
      e = k("div"), l && l.c(), n = Q(), i = k("div"), w(o.$$.fragment), _(i, "class", "rcb-ui-main svelte-1qect5g"), _(e, "class", "rcb-ui-layout svelte-1qect5g"), _(
        e,
        "style",
        /*colorVariables*/
        t[7]
      );
    },
    m(c, a) {
      p(c, e, a), l && l.m(e, null), M(e, n), M(e, i), b(o, i, null), s = !0;
    },
    p(c, a) {
      a & /*state*/
      64 && (r = /*statesWhereOfferDetailsAreShown*/
      c[9].includes(
        /*state*/
        c[6]
      )), r ? l ? (l.p(c, a), a & /*state*/
      64 && f(l, 1)) : (l = ht(c), l.c(), f(l, 1), l.m(e, n)) : l && (H(), d(l, 1, 1, () => {
        l = null;
      }), K());
      const u = {};
      a & /*$$scope, brandingInfo, state, lastError, paymentInfoCollectionMetadata, productDetails*/
      67108988 && (u.$$scope = { dirty: a, ctx: c }), o.$set(u);
    },
    i(c) {
      s || (f(l), f(o.$$.fragment, c), s = !0);
    },
    o(c) {
      d(l), d(o.$$.fragment, c), s = !1;
    },
    d(c) {
      c && g(e), l && l.d(), I(o);
    }
  };
}
function Lo(t) {
  let e, r, n;
  return r = new lo({
    props: {
      condition: (
        /*asModal*/
        t[0]
      ),
      $$slots: { default: [Oo] },
      $$scope: { ctx: t }
    }
  }), {
    c() {
      e = k("div"), w(r.$$.fragment), _(e, "class", "rcb-ui-container svelte-1qect5g");
    },
    m(i, o) {
      p(i, e, o), b(r, e, null), n = !0;
    },
    p(i, [o]) {
      const s = {};
      o & /*asModal*/
      1 && (s.condition = /*asModal*/
      i[0]), o & /*$$scope, brandingInfo, state, lastError, paymentInfoCollectionMetadata, productDetails, purchases*/
      67108990 && (s.$$scope = { dirty: o, ctx: i }), r.$set(s);
    },
    i(i) {
      n || (f(r.$$.fragment, i), n = !0);
    },
    o(i) {
      d(r.$$.fragment, i), n = !1;
    },
    d(i) {
      i && g(e), I(r);
    }
  };
}
function xo(t, e, r) {
  var et, tt;
  let { asModal: n = !0 } = e, { customerEmail: i } = e, { appUserId: o } = e, { rcPackage: s } = e, { purchaseOption: l } = e, { onFinished: c } = e, { onError: a } = e, { onClose: u } = e, { purchases: m } = e, { backend: h } = e, { purchaseOperationHelper: y } = e;
  const E = Object.entries(pe).map(([D, Le]) => `--rc-color-${D}: ${Le}`).join("; ");
  let B = null, A = null, $ = null, R = null;
  const C = ((et = s == null ? void 0 : s.rcBillingProduct) == null ? void 0 : et.identifier) ?? null, ve = (tt = s == null ? void 0 : s.rcBillingProduct) == null ? void 0 : tt.defaultSubscriptionOption, F = l || ve;
  let S = "present-offer";
  const $e = [
    "present-offer",
    "needs-auth-info",
    "processing-auth-info",
    "needs-payment-info",
    "polling-purchase-status",
    "loading"
  ];
  Se(async () => {
    if (r(2, B = s.rcBillingProduct), r(3, A = await h.getBrandingInfo()), S === "present-offer") {
      i ? Ze() : r(6, S = "needs-auth-info");
      return;
    }
  });
  const Be = () => {
    u();
  }, Ze = () => {
    if (C === null) {
      fe(new Y(O.ErrorSettingUpPurchase, "Product ID was not set before purchase."));
      return;
    } else
      S === "present-offer" && r(6, S = "loading");
    if (!i) {
      fe(new Y(O.MissingEmailError));
      return;
    }
    y.startPurchase(o, C, F, i, s.rcBillingProduct.presentedOfferingIdentifier).then((D) => {
      if (D.next_action === "collect_payment_info") {
        r(5, R = null), r(6, S = "needs-payment-info"), r(4, $ = D);
        return;
      }
      if (D.next_action === "completed") {
        r(5, R = null), r(6, S = "success");
        return;
      }
    }).catch((D) => {
      fe(D);
    });
  }, Yt = (D) => {
    if (S === "needs-auth-info") {
      D && (r(14, i = D.email), r(6, S = "processing-auth-info")), Ze();
      return;
    }
    if (S === "needs-payment-info") {
      r(6, S = "polling-purchase-status"), y.pollCurrentPurchaseForCompletion().then(() => {
        r(6, S = "success");
      }).catch((Le) => {
        fe(Le);
      });
      return;
    }
    if (S === "success" || S === "error") {
      c();
      return;
    }
    r(6, S = "success");
  }, fe = (D) => {
    if (S === "processing-auth-info") {
      r(5, R = D), r(6, S = "needs-auth-info");
      return;
    }
    r(5, R = D), r(6, S = "error");
  }, Ht = () => {
    a(R ?? new Y(O.UnknownError, "Unknown error without state set."));
  };
  return t.$$set = (D) => {
    "asModal" in D && r(0, n = D.asModal), "customerEmail" in D && r(14, i = D.customerEmail), "appUserId" in D && r(15, o = D.appUserId), "rcPackage" in D && r(16, s = D.rcPackage), "purchaseOption" in D && r(17, l = D.purchaseOption), "onFinished" in D && r(18, c = D.onFinished), "onError" in D && r(19, a = D.onError), "onClose" in D && r(20, u = D.onClose), "purchases" in D && r(1, m = D.purchases), "backend" in D && r(21, h = D.backend), "purchaseOperationHelper" in D && r(22, y = D.purchaseOperationHelper);
  }, [
    n,
    m,
    B,
    A,
    $,
    R,
    S,
    E,
    F,
    $e,
    Be,
    Yt,
    fe,
    Ht,
    i,
    o,
    s,
    l,
    c,
    a,
    u,
    h,
    y
  ];
}
class Fo extends U {
  constructor(e) {
    super(), N(
      this,
      e,
      xo,
      Lo,
      T,
      {
        asModal: 0,
        customerEmail: 14,
        appUserId: 15,
        rcPackage: 16,
        purchaseOption: 17,
        onFinished: 18,
        onError: 19,
        onClose: 20,
        purchases: 1,
        backend: 21,
        purchaseOperationHelper: 22
      },
      Mo
    );
  }
}
function Go(t) {
  return t.expires_date == null ? !0 : new Date(t.expires_date) > /* @__PURE__ */ new Date();
}
function Yo(t, e, r, n) {
  const i = e.product_identifier;
  if (i in r)
    return Ho(
      t,
      e,
      r[i]
    );
  if (i in n)
    return Ko(
      t,
      e,
      n[i]
    );
  throw new z(
    Z.CustomerInfoError,
    "Could not find entitlement product in subscriptions or non-subscriptions."
  );
}
function Ho(t, e, r) {
  return {
    identifier: t,
    isActive: Go(e),
    willRenew: Jo(e, r),
    store: (r == null ? void 0 : r.store) ?? "unknown",
    latestPurchaseDate: new Date(e.purchase_date),
    originalPurchaseDate: new Date(e.purchase_date),
    expirationDate: Ne(e.expires_date),
    productIdentifier: e.product_identifier,
    unsubscribeDetectedAt: Ne(
      r == null ? void 0 : r.unsubscribe_detected_at
    ),
    billingIssueDetectedAt: Ne(
      r == null ? void 0 : r.billing_issues_detected_at
    ),
    isSandbox: (r == null ? void 0 : r.is_sandbox) ?? !1,
    periodType: (r == null ? void 0 : r.period_type) ?? "normal"
  };
}
function Ko(t, e, r) {
  return {
    identifier: t,
    isActive: !0,
    willRenew: !1,
    store: r.store,
    latestPurchaseDate: new Date(e.purchase_date),
    originalPurchaseDate: new Date(
      r.original_purchase_date
    ),
    expirationDate: null,
    productIdentifier: e.product_identifier,
    unsubscribeDetectedAt: null,
    billingIssueDetectedAt: null,
    isSandbox: r.is_sandbox,
    periodType: "normal"
  };
}
function qo(t, e, r) {
  const n = {}, i = {};
  for (const o in t) {
    const s = Yo(
      o,
      t[o],
      e,
      r
    );
    n[o] = s, s.isActive && (i[o] = s);
  }
  return {
    all: n,
    active: i
  };
}
function Ne(t) {
  return t == null ? null : new Date(t);
}
function jo(t) {
  const e = Wo(t), r = t.subscriber, n = Xo(
    r.non_subscriptions
  );
  return {
    entitlements: qo(
      r.entitlements,
      r.subscriptions,
      n
    ),
    allExpirationDatesByProduct: e,
    allPurchaseDatesByProduct: Vo(
      t,
      n
    ),
    activeSubscriptions: zo(e),
    managementURL: r.management_url,
    requestDate: new Date(t.request_date),
    firstSeenDate: new Date(r.first_seen),
    originalPurchaseDate: Ne(
      r.original_purchase_date
    ),
    originalAppUserId: t.subscriber.original_app_user_id
  };
}
function Jo(t, e) {
  if (e == null)
    return !1;
  const r = e.store == "promotional", n = t.expires_date == null, i = e.unsubscribe_detected_at != null, o = e.billing_issues_detected_at != null;
  return !(r || n || i || o);
}
function Vo(t, e) {
  const r = {};
  for (const n in t.subscriber.subscriptions) {
    const i = t.subscriber.subscriptions[n];
    r[n] = new Date(
      i.purchase_date
    );
  }
  for (const n in e) {
    const i = e[n].purchase_date;
    i == null ? r[n] = null : r[n] = new Date(i);
  }
  return r;
}
function Wo(t) {
  const e = {};
  for (const r in t.subscriber.subscriptions) {
    const n = t.subscriber.subscriptions[r];
    n.expires_date == null ? e[r] = null : e[r] = new Date(
      n.expires_date
    );
  }
  return e;
}
function zo(t) {
  const e = /* @__PURE__ */ new Set(), r = /* @__PURE__ */ new Date();
  for (const n in t) {
    const i = t[n];
    (i == null || i > r) && e.add(n);
  }
  return e;
}
function Xo(t) {
  const e = {};
  for (const r in t) {
    if (t[r].length === 0)
      continue;
    const n = t[r].length;
    e[r] = t[r][n - 1];
  }
  return e;
}
function Zo(t) {
  if (!/^rcb_[a-zA-Z0-9_.-]+$/.test(t))
    throw new z(
      Z.InvalidCredentialsError,
      "Invalid API key. Use your RevenueCat Billing API key."
    );
}
function es(t) {
  if ((/* @__PURE__ */ new Set([
    "no_user",
    "null",
    "none",
    "nil",
    "(null)",
    "NaN",
    "\\x00",
    "",
    "unidentified",
    "undefined",
    "unknown"
  ])).has(t) || t.includes("/"))
    throw new z(
      Z.InvalidAppUserIdError,
      'Provided user id: "' + t + '" is not valid. See https://www.revenuecat.com/docs/customers/user-ids#tips-for-setting-app-user-ids for more information.'
    );
}
function ts(t) {
  if (t != null && t.endsWith("/"))
    throw new z(
      Z.ConfigurationError,
      "Invalid proxy URL. The proxy URL should not end with a trailing slash."
    );
}
const X = class X {
  /** @internal */
  constructor(e, r, n = je) {
    /** @internal */
    P(this, "_API_KEY");
    /** @internal */
    P(this, "_appUserId");
    /** @internal */
    P(this, "backend");
    /** @internal */
    P(this, "purchaseOperationHelper");
    /** @internal */
    P(this, "toOfferings", (e, r) => {
      const n = e.offerings.find(
        (l) => l.identifier === e.current_offering_id
      ) ?? null, i = {};
      r.product_details.forEach((l) => {
        i[l.identifier] = l;
      });
      const o = n == null ? null : it(n, i), s = {};
      return e.offerings.forEach((l) => {
        const c = it(l, i);
        c != null && (s[l.identifier] = c);
      }), Object.keys(s).length == 0 && G.debugLog(
        "Empty offerings. Please make sure you've configured offerings correctly in the RevenueCat dashboard and that the products are properly configured."
      ), {
        all: s,
        current: o
      };
    });
    this._API_KEY = e, this._appUserId = r, qe(e) && G.debugLog("Initializing Purchases SDK with sandbox API Key"), this.backend = new yo(this._API_KEY, n), this.purchaseOperationHelper = new Hn(this.backend);
  }
  /**
   * Set the log level. Logs of the given level and below will be printed
   * in the console.
   * Default is `LogLevel.Silent` so no logs will be printed in the console.
   * @param logLevel - LogLevel to set.
   */
  static setLogLevel(e) {
    G.setLogLevel(e);
  }
  /**
   * Get the singleton instance of Purchases. It's preferred to use the instance
   * obtained from the {@link Purchases.configure} method when possible.
   * @throws {@link UninitializedPurchasesError} if the instance has not been initialized yet.
   */
  static getSharedInstance() {
    if (X.isConfigured())
      return X.instance;
    throw new Yn();
  }
  /**
   * Returns whether the Purchases SDK is configured or not.
   */
  static isConfigured() {
    return X.instance !== void 0;
  }
  /**
   * Configures the Purchases SDK. This should be called as soon as your app
   * has a unique user id for your user. You should only call this once, and
   * keep the returned instance around for use throughout your application.
   * @param apiKey - RevenueCat API Key. Can be obtained from the RevenueCat dashboard.
   * @param appUserId - Your unique id for identifying the user.
   * @param httpConfig - Advanced http configuration to customise the SDK usage {@link HttpConfig}.
   * @throws {@link PurchasesError} if the API key or user id are invalid.
   */
  static configure(e, r, n = je) {
    return X.instance !== void 0 && G.warnLog(
      "Purchases is already initialized. You normally should only configure Purchases once. Creating and returning new instance."
    ), Zo(e), es(r), ts(n.proxyURL), X.instance = new X(e, r, n), X.getSharedInstance();
  }
  /**
   * Fetch the configured offerings for this user. You can configure these
   * in the RevenueCat dashboard.
   */
  async getOfferings() {
    const e = this._appUserId, r = await this.backend.getOfferings(e), n = r.offerings.flatMap((o) => o.packages).map((o) => o.platform_product_identifier), i = await this.backend.getProducts(
      e,
      n
    );
    return this.logMissingProductIds(n, i.product_details), this.toOfferings(r, i);
  }
  /**
   * Convenience method to check whether a user is entitled to a specific
   * entitlement. This will use {@link Purchases.getCustomerInfo} under the hood.
   * @param entitlementIdentifier - The entitlement identifier you want to check.
   * @returns Whether the user is entitled to the specified entitlement
   * @throws {@link PurchasesError} if there is an error while fetching the customer info.
   * @see {@link Purchases.getCustomerInfo}
   */
  async isEntitledTo(e) {
    const r = await this.getCustomerInfo();
    return e in r.entitlements.active;
  }
  /**
   * Method to perform a purchase for a given package. You can obtain the
   * package from {@link Purchases.getOfferings}. This method will present the purchase
   * form on your site, using the given HTML element as the mount point, if
   * provided, or as a modal if not.
   * @deprecated - please use .purchase
   * @param rcPackage - The package you want to purchase. Obtained from {@link Purchases.getOfferings}.
   * @param customerEmail - The email of the user. If undefined, RevenueCat will ask the customer for their email.
   * @param htmlTarget - The HTML element where the billing view should be added. If undefined, a new div will be created at the root of the page and appended to the body.
   * @returns a Promise for the customer info after the purchase is completed successfully.
   * @throws {@link PurchasesError} if there is an error while performing the purchase. If the {@link PurchasesError.errorCode} is {@link ErrorCode.UserCancelledError}, the user cancelled the purchase.
   */
  purchasePackage(e, r, n) {
    return this.purchase({
      rcPackage: e,
      customerEmail: r,
      htmlTarget: n
    });
  }
  /**
   * Method to perform a purchase for a given package. You can obtain the
   * package from {@link Purchases.getOfferings}. This method will present the purchase
   * form on your site, using the given HTML element as the mount point, if
   * provided, or as a modal if not.
   * @param params - The parameters object to customise the purchase flow. Check {@link PurchaseParams}
   * @returns a Promise for the customer info after the purchase is completed successfully.
   * @throws {@link PurchasesError} if there is an error while performing the purchase. If the {@link PurchasesError.errorCode} is {@link ErrorCode.UserCancelledError}, the user cancelled the purchase.
   */
  purchase(e) {
    const { rcPackage: r, purchaseOption: n, htmlTarget: i, customerEmail: o } = e;
    let s = i ?? document.getElementById("rcb-ui-root");
    if (s === null) {
      const u = document.createElement("div");
      u.className = "rcb-ui-root", document.body.appendChild(u), s = u;
    }
    if (s === null)
      throw new Error(
        "Could not generate a mount point for the billing widget"
      );
    const l = s, c = !i, a = this._appUserId;
    return G.debugLog(
      `Presenting purchase form for package ${r.identifier}`
    ), new Promise((u, m) => {
      new Fo({
        target: l,
        props: {
          appUserId: a,
          rcPackage: r,
          purchaseOption: n,
          customerEmail: o,
          onFinished: async () => {
            G.debugLog("Purchase finished"), l.innerHTML = "", u({
              customerInfo: await this._getCustomerInfoForUserId(a)
            });
          },
          onClose: () => {
            l.innerHTML = "", G.debugLog("Purchase cancelled by user"), m(new z(Z.UserCancelledError));
          },
          onError: (h) => {
            l.innerHTML = "", m(z.getForPurchasesFlowError(h));
          },
          purchases: this,
          backend: this.backend,
          purchaseOperationHelper: this.purchaseOperationHelper,
          asModal: c
        }
      });
    });
  }
  /**
   * Gets latest available {@link CustomerInfo}.
   * @returns The latest {@link CustomerInfo}.
   * @throws {@link PurchasesError} if there is an error while fetching the customer info.
   */
  async getCustomerInfo() {
    return await this._getCustomerInfoForUserId(this._appUserId);
  }
  /**
   * Gets the current app user id.
   */
  getAppUserId() {
    return this._appUserId;
  }
  /**
   * Change the current app user id. Returns the customer info for the new
   * user id.
   * @param newAppUserId - The user id to change to.
   */
  async changeUser(e) {
    return this._appUserId = e, await this.getCustomerInfo();
  }
  /** @internal */
  logMissingProductIds(e, r) {
    const n = {};
    r.forEach(
      (o) => n[o.identifier] = o
    );
    const i = [];
    e.forEach((o) => {
      n[o] === void 0 && i.push(o);
    }), i.length > 0 && G.debugLog(
      `Could not find product data for product ids: 
        ${i.join()}. 
        Please check that your product configuration is correct.`
    );
  }
  /**
   * @returns Whether the SDK is using a sandbox API Key.
   */
  isSandbox() {
    return qe(this._API_KEY);
  }
  /**
   * Closes the Purchases instance. You should never have to do this normally.
   */
  close() {
    X.instance === this ? X.instance = void 0 : G.warnLog(
      "Trying to close a Purchases instance that is not the current instance. Ignoring."
    );
  }
  /** @internal */
  async _getCustomerInfoForUserId(e) {
    const r = await this.backend.getCustomerInfo(e);
    return jo(r);
  }
};
/** @internal */
P(X, "instance");
let $t = X;
export {
  Z as ErrorCode,
  W as LogLevel,
  zt as PackageType,
  $t as Purchases,
  z as PurchasesError,
  Yn as UninitializedPurchasesError
};
